var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetTrackingVehicles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.041,
    height: 28.953,
    viewBox: "0 0 36.041 28.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61259",
    "data-name": "Group 61259",
    transform: "translate(-45 -61.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61691",
    "data-name": "Group 61691",
    transform: "translate(45 61.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61266",
    "data-name": "Group 61266",
    transform: "translate(1.018 5.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61265",
    "data-name": "Group 61265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61259-2",
    "data-name": "Group 61259",
    transform: "translate(0 3.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35336",
    "data-name": "Path 35336",
    d: "M76.574,166.663v1.064l-21.4-12.362V154.3Z",
    transform: "translate(-55.173 -154.301)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61260",
    "data-name": "Group 61260",
    transform: "translate(0.569 5.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35337",
    "data-name": "Path 35337",
    d: "M87.842,182.805v2.332L60.855,169.549v-2.332Z",
    transform: "translate(-60.855 -167.217)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61262",
    "data-name": "Group 61262",
    transform: "translate(27.552 16.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61261",
    "data-name": "Group 61261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35338",
    "data-name": "Path 35338",
    d: "M336.773,285.939l-6.393,3.7v2.332l6.393-3.694Z",
    transform: "translate(-330.38 -285.939)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61264",
    "data-name": "Group 61264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61263",
    "data-name": "Group 61263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35339",
    "data-name": "Path 35339",
    d: "M82.968,129.525l-6.395,3.718-21.4-12.362,6.4-3.718Z",
    transform: "translate(-55.173 -117.163)",
    fill: "#4e4d58"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61268",
    "data-name": "Group 61268",
    transform: "translate(28.946 26.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61267",
    "data-name": "Group 61267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35340",
    "data-name": "Path 35340",
    d: "M334.931,328.864l-.1.114v.111a.071.071,0,0,1-.012.036.088.088,0,0,1-.03.029l-.5.288.008.1-.034.037-.115-.067a.022.022,0,0,1-.012-.022v-.27a.071.071,0,0,1,.012-.036.087.087,0,0,1,.029-.029l.078-.044.535-.307a.034.034,0,0,1,.029,0Z",
    transform: "translate(-334.131 -328.795)",
    fill: "#4e4d58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35341",
    "data-name": "Path 35341",
    d: "M334.292,333.015l-.034.037-.115-.067a.022.022,0,0,1-.012-.022v-.27a.071.071,0,0,1,.012-.036l.115.067S334.279,332.89,334.292,333.015Z",
    transform: "translate(-334.131 -332.27)",
    fill: "#393b47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35342",
    "data-name": "Path 35342",
    d: "M335.933,329.825l-.535.307-.078.044a.034.034,0,0,1-.029,0,.022.022,0,0,1-.012-.022v-.27a.071.071,0,0,1,.012-.036.089.089,0,0,1,.029-.029l.078-.044.535-.307a.034.034,0,0,1,.029,0,.022.022,0,0,1,.012.022v.27a.071.071,0,0,1-.012.036A.086.086,0,0,1,335.933,329.825Z",
    transform: "translate(-335.164 -329.399)",
    fill: "#5e5e6a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35343",
    "data-name": "Path 35343",
    d: "M336.133,329.722v.2a.054.054,0,0,1-.009.026.074.074,0,0,1-.023.023l-.532.3-.01.013-.045.06-.037-.023s0-.14,0-.14v-.135a.056.056,0,0,1,.009-.027.078.078,0,0,1,.023-.022l.612-.351a.025.025,0,0,1,.011,0l.039.023Z",
    transform: "translate(-335.341 -329.564)",
    fill: "#e13d22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35344",
    "data-name": "Path 35344",
    d: "M335.562,333.632l0,.056-.045.06-.037-.023s0-.14,0-.14v-.135a.056.056,0,0,1,.009-.027.259.259,0,0,1,.039.023C335.524,333.452,335.562,333.632,335.562,333.632Z",
    transform: "translate(-335.34 -332.96)",
    fill: "#ac2f11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35345",
    "data-name": "Path 35345",
    d: "M335.863,330.558v-.275a.053.053,0,0,1,.009-.026.072.072,0,0,1,.023-.023l.612-.351a.024.024,0,0,1,.011,0v.276a.054.054,0,0,1-.009.026.071.071,0,0,1-.023.023l-.612.351a.023.023,0,0,1-.011,0Z",
    transform: "translate(-335.69 -329.771)",
    fill: "#fd6445"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61270",
    "data-name": "Group 61270",
    transform: "translate(33.963 23.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61269",
    "data-name": "Group 61269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35346",
    "data-name": "Path 35346",
    d: "M385.045,300.313l-.1.114v.111a.072.072,0,0,1-.012.036.088.088,0,0,1-.03.029l-.5.288.008.1-.034.037-.115-.067a.022.022,0,0,1-.012-.022v-.27a.072.072,0,0,1,.012-.036.087.087,0,0,1,.029-.029l.078-.044.535-.307a.034.034,0,0,1,.029,0Z",
    transform: "translate(-384.245 -300.244)",
    fill: "#4e4d58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35347",
    "data-name": "Path 35347",
    d: "M384.407,304.464l-.034.037-.115-.067a.022.022,0,0,1-.012-.022v-.27a.072.072,0,0,1,.012-.036l.115.067S384.394,304.339,384.407,304.464Z",
    transform: "translate(-384.246 -303.718)",
    fill: "#393b47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35348",
    "data-name": "Path 35348",
    d: "M386.05,301.275l-.535.307-.078.044a.034.034,0,0,1-.029,0,.022.022,0,0,1-.012-.022v-.27a.072.072,0,0,1,.012-.036.088.088,0,0,1,.029-.029l.078-.044.535-.307a.034.034,0,0,1,.029,0,.022.022,0,0,1,.012.022v.27a.071.071,0,0,1-.012.036A.088.088,0,0,1,386.05,301.275Z",
    transform: "translate(-385.281 -300.849)",
    fill: "#5e5e6a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35349",
    "data-name": "Path 35349",
    d: "M386.247,301.173v.2a.053.053,0,0,1-.01.026.074.074,0,0,1-.023.023l-.532.3-.01.013-.045.06-.037-.023s0-.14,0-.14V301.5a.055.055,0,0,1,.009-.027.078.078,0,0,1,.023-.022l.612-.351a.026.026,0,0,1,.011,0l.039.023Z",
    transform: "translate(-385.455 -301.014)",
    fill: "#e13d22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35350",
    "data-name": "Path 35350",
    d: "M385.678,305.082l0,.056-.045.06-.037-.023s0-.14,0-.14V304.9a.056.056,0,0,1,.009-.027.258.258,0,0,1,.039.023C385.64,304.9,385.678,305.082,385.678,305.082Z",
    transform: "translate(-385.456 -304.41)",
    fill: "#ac2f11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35351",
    "data-name": "Path 35351",
    d: "M385.978,302.008v-.275a.054.054,0,0,1,.009-.026.071.071,0,0,1,.023-.023l.613-.351a.024.024,0,0,1,.011,0v.276a.053.053,0,0,1-.009.026.071.071,0,0,1-.023.023l-.612.351a.024.024,0,0,1-.011,0Z",
    transform: "translate(-385.805 -301.22)",
    fill: "#fd6445"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35352",
    "data-name": "Path 35352",
    d: "M352.963,306.352l-2.972,1.716v-.577l2.972-1.716Z",
    transform: "translate(-319.457 -281.31)",
    fill: "#b9a48f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61283",
    "data-name": "Group 61283",
    transform: "translate(11.688 17.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61282",
    "data-name": "Group 61282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61272",
    "data-name": "Group 61272",
    transform: "translate(0.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61271",
    "data-name": "Group 61271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35353",
    "data-name": "Path 35353",
    d: "M162.4,233.669l1.38-.8a.15.15,0,0,1,.151.015l-1.38.8A.15.15,0,0,0,162.4,233.669Z",
    transform: "translate(-162.402 -232.853)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61274",
    "data-name": "Group 61274",
    transform: "translate(2.501 2.976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61273",
    "data-name": "Group 61273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35354",
    "data-name": "Path 35354",
    d: "M188.112,262.72l-1.38.8a.148.148,0,0,0,.062-.136l1.38-.8A.148.148,0,0,1,188.112,262.72Z",
    transform: "translate(-186.732 -262.584)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61276",
    "data-name": "Group 61276",
    transform: "translate(2.563 1.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61275",
    "data-name": "Group 61275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35355",
    "data-name": "Path 35355",
    d: "M187.354,249.93l1.38-.8,0,1.347-1.38.8Z",
    transform: "translate(-187.35 -249.128)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61278",
    "data-name": "Group 61278",
    transform: "translate(0.216 0.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61277",
    "data-name": "Group 61277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35356",
    "data-name": "Path 35356",
    d: "M163.911,233.947l1.38-.8,2.139,1.235-1.38.8Z",
    transform: "translate(-163.911 -233.145)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61280",
    "data-name": "Group 61280",
    transform: "translate(2.356 1.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61279",
    "data-name": "Group 61279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35357",
    "data-name": "Path 35357",
    d: "M185.279,246.284l1.38-.8a.465.465,0,0,1,.211.365l-1.38.8A.465.465,0,0,0,185.279,246.284Z",
    transform: "translate(-185.279 -245.482)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61281",
    "data-name": "Group 61281",
    transform: "translate(0 0.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35358",
    "data-name": "Path 35358",
    d: "M164.106,242.127a.465.465,0,0,1,.211.365l0,1.347c0,.134-.1.189-.213.121l-2.139-1.235a.466.466,0,0,1-.211-.366l0-1.347c0-.134.1-.188.213-.12Z",
    transform: "translate(-161.75 -240.863)",
    fill: "#393b47"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61440",
    "data-name": "Group 61440",
    transform: "translate(0.632 11.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61439",
    "data-name": "Group 61439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61284",
    "data-name": "Group 61284",
    transform: "translate(0.294 0.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35359",
    "data-name": "Path 35359",
    d: "M54.254,179.058l2.07-1.2,0,1.724-2.07,1.2Z",
    transform: "translate(-54.249 -177.855)",
    fill: "#b05f27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61355",
    "data-name": "Group 61355",
    transform: "translate(0.669 0.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61354",
    "data-name": "Group 61354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61286",
    "data-name": "Group 61286",
    transform: "translate(0.451 2.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61285",
    "data-name": "Group 61285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35360",
    "data-name": "Path 35360",
    d: "M62.5,213.914l1.291-.751.095-.054-1.291.75Z",
    transform: "translate(-62.5 -213.11)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61287",
    "data-name": "Group 61287",
    transform: "translate(1.27 4.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35361",
    "data-name": "Path 35361",
    d: "M70.73,224.414l1.291-.751-.053.11-1.291.75Z",
    transform: "translate(-70.677 -223.663)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61288",
    "data-name": "Group 61288",
    transform: "translate(0.081 2.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35362",
    "data-name": "Path 35362",
    d: "M58.806,204.6l1.291-.751.123.014-1.291.75Z",
    transform: "translate(-58.806 -203.849)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61289",
    "data-name": "Group 61289",
    transform: "translate(2.028 4.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35363",
    "data-name": "Path 35363",
    d: "M78.247,229.473l1.291-.75v.154l-1.291.751Z",
    transform: "translate(-78.247 -228.723)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61290",
    "data-name": "Group 61290",
    transform: "translate(0.001 1.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35364",
    "data-name": "Path 35364",
    d: "M58,195.95l1.291-.751.133.077-1.291.75Z",
    transform: "translate(-58.003 -195.199)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61292",
    "data-name": "Group 61292",
    transform: "translate(0.716 1.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61291",
    "data-name": "Group 61291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35365",
    "data-name": "Path 35365",
    d: "M66.441,200.94a2.587,2.587,0,0,0,1.172,2.031l-1.291.75a2.588,2.588,0,0,1-1.172-2.031Z",
    transform: "translate(-65.15 -200.94)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61293",
    "data-name": "Group 61293",
    transform: "translate(2.67 4.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35366",
    "data-name": "Path 35366",
    d: "M84.668,231.134l1.291-.75.049.172-1.291.75Z",
    transform: "translate(-84.668 -230.384)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61294",
    "data-name": "Group 61294",
    transform: "translate(0.212 0.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35367",
    "data-name": "Path 35367",
    d: "M60.115,188.714l1.291-.75.121.131-1.291.75Z",
    transform: "translate(-60.115 -187.964)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61296",
    "data-name": "Group 61296",
    transform: "translate(0.716 1.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61295",
    "data-name": "Group 61295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35368",
    "data-name": "Path 35368",
    d: "M66.784,193.421a.822.822,0,0,0-.343.753l-1.291.751a.821.821,0,0,1,.343-.753Z",
    transform: "translate(-65.149 -193.421)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61298",
    "data-name": "Group 61298",
    transform: "translate(1.889 3.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61297",
    "data-name": "Group 61297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35369",
    "data-name": "Path 35369",
    d: "M78.151,221.222a.829.829,0,0,0,.836.081l-1.291.751a.829.829,0,0,1-.837-.081Z",
    transform: "translate(-76.86 -221.222)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61300",
    "data-name": "Group 61300",
    transform: "translate(3.232 4.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61299",
    "data-name": "Group 61299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35370",
    "data-name": "Path 35370",
    d: "M90.276,229.35l1.291-.75.094.163-1.291.751Z",
    transform: "translate(-90.276 -228.6)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61302",
    "data-name": "Group 61302",
    transform: "translate(0.659 0.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61301",
    "data-name": "Group 61301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35371",
    "data-name": "Path 35371",
    d: "M64.574,184.832l1.291-.75.094.163L64.668,185Z",
    transform: "translate(-64.574 -184.082)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61304",
    "data-name": "Group 61304",
    transform: "translate(0.459 0.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61303",
    "data-name": "Group 61303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35372",
    "data-name": "Path 35372",
    d: "M62.581,184.946l1.291-.75.2-.114-1.291.75Z",
    transform: "translate(-62.581 -184.082)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61305",
    "data-name": "Group 61305",
    transform: "translate(3.232 4.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35373",
    "data-name": "Path 35373",
    d: "M90.5,226.93l1.291-.75a.906.906,0,0,1-.219.242l-1.291.75A.908.908,0,0,0,90.5,226.93Z",
    transform: "translate(-90.277 -226.18)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61306",
    "data-name": "Group 61306",
    transform: "translate(0.753 0.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35374",
    "data-name": "Path 35374",
    d: "M65.513,185.876l1.291-.751a.953.953,0,0,1,.362-.065l-1.291.75A.956.956,0,0,0,65.513,185.876Z",
    transform: "translate(-65.513 -185.061)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61308",
    "data-name": "Group 61308",
    transform: "translate(3.574 4.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61307",
    "data-name": "Group 61307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35375",
    "data-name": "Path 35375",
    d: "M93.8,225.9l1.291-.75-.112.234-1.291.75Z",
    transform: "translate(-93.689 -225.153)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61310",
    "data-name": "Group 61310",
    transform: "translate(3.563 4.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61309",
    "data-name": "Group 61309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35376",
    "data-name": "Path 35376",
    d: "M93.582,224.6l1.291-.75.122.131-1.291.75Z",
    transform: "translate(-93.582 -223.847)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61312",
    "data-name": "Group 61312",
    transform: "translate(2.725 3.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61311",
    "data-name": "Group 61311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35377",
    "data-name": "Path 35377",
    d: "M86.506,215.26l-1.291.751a.822.822,0,0,0,.343-.754l1.291-.75A.822.822,0,0,1,86.506,215.26Z",
    transform: "translate(-85.215 -214.506)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61314",
    "data-name": "Group 61314",
    transform: "translate(1.06 0.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61313",
    "data-name": "Group 61313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35378",
    "data-name": "Path 35378",
    d: "M68.579,193.456l1.291-.75a.83.83,0,0,1,.837.081l-1.291.751A.83.83,0,0,0,68.579,193.456Z",
    transform: "translate(-68.579 -192.626)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61316",
    "data-name": "Group 61316",
    transform: "translate(1.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61315",
    "data-name": "Group 61315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35379",
    "data-name": "Path 35379",
    d: "M68.633,184.1l1.291-.751.262.031-1.291.751Z",
    transform: "translate(-68.633 -183.35)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61318",
    "data-name": "Group 61318",
    transform: "translate(1.328 0.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61317",
    "data-name": "Group 61317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35380",
    "data-name": "Path 35380",
    d: "M71.255,184.413l1.291-.751.049.169-1.291.75Z",
    transform: "translate(-71.255 -183.662)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61319",
    "data-name": "Group 61319",
    transform: "translate(3.563 3.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35381",
    "data-name": "Path 35381",
    d: "M93.67,220.236l1.291-.75a1.688,1.688,0,0,1-.088.437l-1.291.751A1.69,1.69,0,0,0,93.67,220.236Z",
    transform: "translate(-93.582 -219.486)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61320",
    "data-name": "Group 61320",
    transform: "translate(1.376 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35382",
    "data-name": "Path 35382",
    d: "M71.741,186.1l1.291-.75a1.744,1.744,0,0,1,.382.139l-1.291.75A1.752,1.752,0,0,0,71.741,186.1Z",
    transform: "translate(-71.741 -185.351)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61322",
    "data-name": "Group 61322",
    transform: "translate(0.717 1.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61321",
    "data-name": "Group 61321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35383",
    "data-name": "Path 35383",
    d: "M67.5,202.318a.973.973,0,0,1-.172.6c-.208.272-.583.318-1.008.072a2.585,2.585,0,0,1-1.173-2.03c0-.52.26-.825.638-.832a1.058,1.058,0,0,1,.542.16A2.589,2.589,0,0,1,67.5,202.318Z",
    transform: "translate(-65.151 -200.127)",
    fill: "#f2b929"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61324",
    "data-name": "Group 61324",
    transform: "translate(1.182 1.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61323",
    "data-name": "Group 61323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35384",
    "data-name": "Path 35384",
    d: "M71.686,202.317a.973.973,0,0,1-.172.6,1.057,1.057,0,0,1-.542-.16,2.588,2.588,0,0,1-1.173-2.032.971.971,0,0,1,.172-.6,1.059,1.059,0,0,1,.542.16A2.589,2.589,0,0,1,71.686,202.317Z",
    transform: "translate(-69.799 -200.126)",
    fill: "#fc8b13"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61326",
    "data-name": "Group 61326",
    transform: "translate(1.896 1.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61325",
    "data-name": "Group 61325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35385",
    "data-name": "Path 35385",
    d: "M76.936,194.983l1.291-.751a2.587,2.587,0,0,1,1.172,2.03l-1.291.75A2.587,2.587,0,0,0,76.936,194.983Z",
    transform: "translate(-76.936 -194.232)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61328",
    "data-name": "Group 61328",
    transform: "translate(3.652 3.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61327",
    "data-name": "Group 61327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35386",
    "data-name": "Path 35386",
    d: "M94.47,217l1.291-.75.133.077-1.291.75Z",
    transform: "translate(-94.47 -216.254)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61330",
    "data-name": "Group 61330",
    transform: "translate(3.784 3.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61329",
    "data-name": "Group 61329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35387",
    "data-name": "Path 35387",
    d: "M95.794,217.773l1.291-.75v.323l-1.291.751Z",
    transform: "translate(-95.793 -217.023)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61332",
    "data-name": "Group 61332",
    transform: "translate(1.758 0.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61331",
    "data-name": "Group 61331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35388",
    "data-name": "Path 35388",
    d: "M75.558,185.946l1.291-.75.282.163-1.291.75Z",
    transform: "translate(-75.558 -185.196)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61334",
    "data-name": "Group 61334",
    transform: "translate(2.039 0.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61333",
    "data-name": "Group 61333"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35389",
    "data-name": "Path 35389",
    d: "M78.366,187.57l1.291-.75v.154l-1.291.751Z",
    transform: "translate(-78.365 -186.82)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61335",
    "data-name": "Group 61335",
    transform: "translate(3.581 2.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35390",
    "data-name": "Path 35390",
    d: "M93.766,212.213l1.291-.75a3.05,3.05,0,0,1,.07.48l-1.291.75A3.051,3.051,0,0,0,93.766,212.213Z",
    transform: "translate(-93.766 -211.463)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61337",
    "data-name": "Group 61337",
    transform: "translate(2.039 0.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61336",
    "data-name": "Group 61336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35391",
    "data-name": "Path 35391",
    d: "M78.365,189.11l1.291-.75a3.03,3.03,0,0,1,.423.344l-1.291.751A3.017,3.017,0,0,0,78.365,189.11Z",
    transform: "translate(-78.365 -188.36)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61338",
    "data-name": "Group 61338",
    transform: "translate(3.239 1.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35392",
    "data-name": "Path 35392",
    d: "M90.35,203.086l1.291-.751a4.124,4.124,0,0,1,.237.552l-1.291.751A4.116,4.116,0,0,0,90.35,203.086Z",
    transform: "translate(-90.35 -202.335)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61339",
    "data-name": "Group 61339",
    transform: "translate(2.721 1.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35393",
    "data-name": "Path 35393",
    d: "M85.176,195.3l1.291-.75a4.146,4.146,0,0,1,.32.436l-1.291.75A4.162,4.162,0,0,0,85.176,195.3Z",
    transform: "translate(-85.176 -194.551)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61341",
    "data-name": "Group 61341",
    transform: "translate(3.476 2.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61340",
    "data-name": "Group 61340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35394",
    "data-name": "Path 35394",
    d: "M92.715,208.6l1.291-.75.124.015-1.291.751Z",
    transform: "translate(-92.715 -207.852)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61343",
    "data-name": "Group 61343",
    transform: "translate(3.6 2.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61342",
    "data-name": "Group 61342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35395",
    "data-name": "Path 35395",
    d: "M93.955,208.754,95.246,208l.1.361-1.291.75Z",
    transform: "translate(-93.955 -208.003)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61345",
    "data-name": "Group 61345",
    transform: "translate(2.721 1.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61344",
    "data-name": "Group 61344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35396",
    "data-name": "Path 35396",
    d: "M85.229,194.206l1.291-.75-.053.11-1.291.75Z",
    transform: "translate(-85.176 -193.456)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61347",
    "data-name": "Group 61347",
    transform: "translate(2.515 0.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61346",
    "data-name": "Group 61346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35397",
    "data-name": "Path 35397",
    d: "M83.119,191.433l1.291-.751.259.278-1.291.75Z",
    transform: "translate(-83.119 -190.682)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61349",
    "data-name": "Group 61349",
    transform: "translate(3.041 1.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61348",
    "data-name": "Group 61348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35398",
    "data-name": "Path 35398",
    d: "M88.37,199.171l1.291-.75.095-.054-1.291.75Z",
    transform: "translate(-88.37 -198.367)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61351",
    "data-name": "Group 61351",
    transform: "translate(3.136 1.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61350",
    "data-name": "Group 61350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35399",
    "data-name": "Path 35399",
    d: "M89.316,199.117l1.291-.75.2.343-1.291.751Z",
    transform: "translate(-89.316 -198.367)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61353",
    "data-name": "Group 61353",
    transform: "translate(0 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61352",
    "data-name": "Group 61352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35400",
    "data-name": "Path 35400",
    d: "M61.778,194.54l-.133-.077a1.684,1.684,0,0,1-.088.437l.122.131-.112.234-.122-.131a.9.9,0,0,1-.219.242l.094.163-.2.115-.094-.163a.958.958,0,0,1-.362.064l.05.172-.262-.031-.048-.169a1.707,1.707,0,0,1-.382-.138v.154l-.282-.163v-.154a3.059,3.059,0,0,1-.423-.344l-.053.11-.259-.277.053-.111a4.226,4.226,0,0,1-.32-.435l-.095.054-.2-.344.095-.054a4.073,4.073,0,0,1-.237-.552l-.124-.014-.1-.361.123.014a3.066,3.066,0,0,1-.07-.48l-.133-.077v-.324l.133.077a1.67,1.67,0,0,1,.088-.437l-.122-.132.112-.233.121.131a.912.912,0,0,1,.219-.243l-.094-.163.2-.114.094.163a.953.953,0,0,1,.362-.065l-.05-.171.262.031.049.169a1.742,1.742,0,0,1,.382.139v-.154l.282.163v.154a3.03,3.03,0,0,1,.423.344l.053-.111.259.278-.053.11a4.144,4.144,0,0,1,.32.436l.095-.054.2.343-.095.054a4.126,4.126,0,0,1,.237.552l.124.015.1.361-.123-.014a3.05,3.05,0,0,1,.07.48l.133.077Zm-1.9.1c.648.374,1.178.073,1.18-.672a2.587,2.587,0,0,0-1.172-2.03c-.648-.374-1.178-.073-1.18.672A2.587,2.587,0,0,0,59.883,194.637Z",
    transform: "translate(-57.994 -190.845)",
    fill: "#2d2f3c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61426",
    "data-name": "Group 61426",
    transform: "translate(5.17 3.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61425",
    "data-name": "Group 61425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61357",
    "data-name": "Group 61357",
    transform: "translate(0.451 2.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61356",
    "data-name": "Group 61356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35401",
    "data-name": "Path 35401",
    d: "M107.458,239.932l1.291-.75.095-.054-1.291.75Z",
    transform: "translate(-107.458 -239.128)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61358",
    "data-name": "Group 61358",
    transform: "translate(1.27 4.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35402",
    "data-name": "Path 35402",
    d: "M115.689,250.432l1.291-.751-.053.11-1.291.75Z",
    transform: "translate(-115.636 -249.681)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61359",
    "data-name": "Group 61359",
    transform: "translate(0.081 2.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35403",
    "data-name": "Path 35403",
    d: "M103.764,230.618l1.291-.751.123.014-1.291.75Z",
    transform: "translate(-103.764 -229.867)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61360",
    "data-name": "Group 61360",
    transform: "translate(2.028 4.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35404",
    "data-name": "Path 35404",
    d: "M123.205,255.491l1.291-.75v.154l-1.291.75Z",
    transform: "translate(-123.205 -254.741)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61361",
    "data-name": "Group 61361",
    transform: "translate(0.001 1.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35405",
    "data-name": "Path 35405",
    d: "M102.961,221.968l1.291-.75.133.077-1.291.75Z",
    transform: "translate(-102.961 -221.218)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61363",
    "data-name": "Group 61363",
    transform: "translate(0.716 1.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61362",
    "data-name": "Group 61362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35406",
    "data-name": "Path 35406",
    d: "M111.4,226.958a2.588,2.588,0,0,0,1.172,2.031l-1.291.75a2.587,2.587,0,0,1-1.172-2.031Z",
    transform: "translate(-110.108 -226.958)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61364",
    "data-name": "Group 61364",
    transform: "translate(2.67 4.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35407",
    "data-name": "Path 35407",
    d: "M129.626,257.152l1.291-.75.049.172-1.291.75Z",
    transform: "translate(-129.626 -256.402)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61365",
    "data-name": "Group 61365",
    transform: "translate(0.212 0.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35408",
    "data-name": "Path 35408",
    d: "M105.073,214.732l1.291-.75.121.131-1.291.75Z",
    transform: "translate(-105.073 -213.982)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61367",
    "data-name": "Group 61367",
    transform: "translate(0.716 1.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61366",
    "data-name": "Group 61366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35409",
    "data-name": "Path 35409",
    d: "M111.743,219.439a.822.822,0,0,0-.343.753l-1.291.75a.821.821,0,0,1,.343-.753Z",
    transform: "translate(-110.108 -219.439)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61369",
    "data-name": "Group 61369",
    transform: "translate(1.889 3.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61368",
    "data-name": "Group 61368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35410",
    "data-name": "Path 35410",
    d: "M123.109,247.24a.829.829,0,0,0,.836.081l-1.291.75a.829.829,0,0,1-.837-.081Z",
    transform: "translate(-121.817 -247.24)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61371",
    "data-name": "Group 61371",
    transform: "translate(3.232 4.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61370",
    "data-name": "Group 61370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35411",
    "data-name": "Path 35411",
    d: "M135.234,255.369l1.291-.751.094.163-1.291.751Z",
    transform: "translate(-135.234 -254.618)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61373",
    "data-name": "Group 61373",
    transform: "translate(0.659 0.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61372",
    "data-name": "Group 61372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35412",
    "data-name": "Path 35412",
    d: "M109.532,210.851l1.291-.751.094.163-1.291.75Z",
    transform: "translate(-109.532 -210.1)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61375",
    "data-name": "Group 61375",
    transform: "translate(0.459 0.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61374",
    "data-name": "Group 61374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35413",
    "data-name": "Path 35413",
    d: "M107.539,210.964l1.291-.75.2-.114-1.291.751Z",
    transform: "translate(-107.539 -210.1)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61376",
    "data-name": "Group 61376",
    transform: "translate(3.232 4.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35414",
    "data-name": "Path 35414",
    d: "M135.453,252.949l1.291-.75a.906.906,0,0,1-.219.242l-1.291.75A.908.908,0,0,0,135.453,252.949Z",
    transform: "translate(-135.234 -252.199)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61377",
    "data-name": "Group 61377",
    transform: "translate(0.753 0.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35415",
    "data-name": "Path 35415",
    d: "M110.472,211.9l1.291-.75a.953.953,0,0,1,.362-.065l-1.291.75A.952.952,0,0,0,110.472,211.9Z",
    transform: "translate(-110.472 -211.08)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61379",
    "data-name": "Group 61379",
    transform: "translate(3.573 4.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61378",
    "data-name": "Group 61378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35416",
    "data-name": "Path 35416",
    d: "M138.759,251.921l1.291-.75-.112.234-1.291.751Z",
    transform: "translate(-138.647 -251.171)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61381",
    "data-name": "Group 61381",
    transform: "translate(3.563 4.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61380",
    "data-name": "Group 61380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35417",
    "data-name": "Path 35417",
    d: "M138.54,250.615l1.291-.75.122.131-1.291.75Z",
    transform: "translate(-138.54 -249.865)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61383",
    "data-name": "Group 61383",
    transform: "translate(2.725 3.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61382",
    "data-name": "Group 61382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35418",
    "data-name": "Path 35418",
    d: "M131.464,241.278l-1.291.751a.823.823,0,0,0,.343-.754l1.291-.75A.822.822,0,0,1,131.464,241.278Z",
    transform: "translate(-130.173 -240.524)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61385",
    "data-name": "Group 61385",
    transform: "translate(1.06 0.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61384",
    "data-name": "Group 61384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35419",
    "data-name": "Path 35419",
    d: "M113.537,219.474l1.291-.75a.829.829,0,0,1,.837.081l-1.291.75A.83.83,0,0,0,113.537,219.474Z",
    transform: "translate(-113.537 -218.644)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61387",
    "data-name": "Group 61387",
    transform: "translate(1.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61386",
    "data-name": "Group 61386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35420",
    "data-name": "Path 35420",
    d: "M113.592,210.119l1.291-.75.262.031-1.291.751Z",
    transform: "translate(-113.592 -209.369)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61389",
    "data-name": "Group 61389",
    transform: "translate(1.328 0.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61388",
    "data-name": "Group 61388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35421",
    "data-name": "Path 35421",
    d: "M116.213,210.431l1.291-.751.049.169-1.291.75Z",
    transform: "translate(-116.213 -209.68)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61390",
    "data-name": "Group 61390",
    transform: "translate(3.563 3.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35422",
    "data-name": "Path 35422",
    d: "M138.628,246.254l1.291-.75a1.691,1.691,0,0,1-.088.437l-1.291.75A1.686,1.686,0,0,0,138.628,246.254Z",
    transform: "translate(-138.54 -245.504)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61391",
    "data-name": "Group 61391",
    transform: "translate(1.376 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35423",
    "data-name": "Path 35423",
    d: "M116.7,212.119l1.291-.75a1.743,1.743,0,0,1,.382.139l-1.291.751A1.743,1.743,0,0,0,116.7,212.119Z",
    transform: "translate(-116.699 -211.369)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61393",
    "data-name": "Group 61393",
    transform: "translate(0.716 1.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61392",
    "data-name": "Group 61392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35424",
    "data-name": "Path 35424",
    d: "M112.461,228.335a.972.972,0,0,1-.172.6c-.208.272-.583.318-1.008.072a2.585,2.585,0,0,1-1.173-2.03c0-.52.26-.825.638-.832a1.057,1.057,0,0,1,.542.16A2.589,2.589,0,0,1,112.461,228.335Z",
    transform: "translate(-110.108 -226.145)",
    fill: "#f2b929"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61395",
    "data-name": "Group 61395",
    transform: "translate(1.182 1.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61394",
    "data-name": "Group 61394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35425",
    "data-name": "Path 35425",
    d: "M116.643,228.335a.972.972,0,0,1-.172.6,1.057,1.057,0,0,1-.542-.16,2.588,2.588,0,0,1-1.173-2.031.972.972,0,0,1,.172-.6,1.057,1.057,0,0,1,.542.16A2.589,2.589,0,0,1,116.643,228.335Z",
    transform: "translate(-114.756 -226.144)",
    fill: "#fc8b13"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61397",
    "data-name": "Group 61397",
    transform: "translate(1.896 1.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61396",
    "data-name": "Group 61396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35426",
    "data-name": "Path 35426",
    d: "M121.9,221l1.291-.75a2.587,2.587,0,0,1,1.172,2.03l-1.291.75A2.588,2.588,0,0,0,121.9,221Z",
    transform: "translate(-121.895 -220.251)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61399",
    "data-name": "Group 61399",
    transform: "translate(3.652 3.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61398",
    "data-name": "Group 61398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35427",
    "data-name": "Path 35427",
    d: "M139.428,243.022l1.291-.75.133.077-1.291.751Z",
    transform: "translate(-139.428 -242.272)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61401",
    "data-name": "Group 61401",
    transform: "translate(3.784 3.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61400",
    "data-name": "Group 61400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35428",
    "data-name": "Path 35428",
    d: "M140.752,243.792l1.291-.751v.324l-1.291.75Z",
    transform: "translate(-140.751 -243.041)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61403",
    "data-name": "Group 61403",
    transform: "translate(1.758 0.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61402",
    "data-name": "Group 61402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35429",
    "data-name": "Path 35429",
    d: "M120.516,211.965l1.291-.751.282.163-1.291.75Z",
    transform: "translate(-120.516 -211.214)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61405",
    "data-name": "Group 61405",
    transform: "translate(2.039 0.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61404",
    "data-name": "Group 61404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35430",
    "data-name": "Path 35430",
    d: "M123.324,213.588l1.291-.75v.154l-1.291.75Z",
    transform: "translate(-123.324 -212.838)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61406",
    "data-name": "Group 61406",
    transform: "translate(3.581 2.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35431",
    "data-name": "Path 35431",
    d: "M138.724,238.231l1.291-.75a3.049,3.049,0,0,1,.07.48l-1.291.75A3.051,3.051,0,0,0,138.724,238.231Z",
    transform: "translate(-138.724 -237.481)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61408",
    "data-name": "Group 61408",
    transform: "translate(2.039 0.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61407",
    "data-name": "Group 61407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35432",
    "data-name": "Path 35432",
    d: "M123.324,215.128l1.291-.75a3.03,3.03,0,0,1,.423.344l-1.291.751A3.016,3.016,0,0,0,123.324,215.128Z",
    transform: "translate(-123.324 -214.378)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61409",
    "data-name": "Group 61409",
    transform: "translate(3.239 1.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35433",
    "data-name": "Path 35433",
    d: "M135.309,229.1l1.291-.75a4.126,4.126,0,0,1,.237.552l-1.291.75A4.113,4.113,0,0,0,135.309,229.1Z",
    transform: "translate(-135.309 -228.354)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61410",
    "data-name": "Group 61410",
    transform: "translate(2.721 1.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35434",
    "data-name": "Path 35434",
    d: "M130.134,221.319l1.291-.75a4.145,4.145,0,0,1,.32.436l-1.291.75A4.153,4.153,0,0,0,130.134,221.319Z",
    transform: "translate(-130.134 -220.569)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61412",
    "data-name": "Group 61412",
    transform: "translate(3.476 2.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61411",
    "data-name": "Group 61411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35435",
    "data-name": "Path 35435",
    d: "M137.673,234.621l1.291-.751.124.015-1.291.751Z",
    transform: "translate(-137.673 -233.87)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61414",
    "data-name": "Group 61414",
    transform: "translate(3.6 2.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61413",
    "data-name": "Group 61413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35436",
    "data-name": "Path 35436",
    d: "M138.913,234.772l1.291-.751.1.361-1.291.75Z",
    transform: "translate(-138.913 -234.021)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61416",
    "data-name": "Group 61416",
    transform: "translate(2.721 1.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61415",
    "data-name": "Group 61415"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35437",
    "data-name": "Path 35437",
    d: "M130.187,220.224l1.291-.75-.053.11-1.291.75Z",
    transform: "translate(-130.134 -219.474)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61418",
    "data-name": "Group 61418",
    transform: "translate(2.515 0.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61417",
    "data-name": "Group 61417"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35438",
    "data-name": "Path 35438",
    d: "M128.077,217.451l1.291-.75.259.278-1.291.75Z",
    transform: "translate(-128.077 -216.701)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61420",
    "data-name": "Group 61420",
    transform: "translate(3.041 1.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61419",
    "data-name": "Group 61419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35439",
    "data-name": "Path 35439",
    d: "M133.328,225.189l1.291-.75.095-.054-1.291.751Z",
    transform: "translate(-133.328 -224.385)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61422",
    "data-name": "Group 61422",
    transform: "translate(3.136 1.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61421",
    "data-name": "Group 61421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35440",
    "data-name": "Path 35440",
    d: "M134.274,225.136l1.291-.751.2.343-1.291.75Z",
    transform: "translate(-134.274 -224.385)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61424",
    "data-name": "Group 61424",
    transform: "translate(0 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61423",
    "data-name": "Group 61423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35441",
    "data-name": "Path 35441",
    d: "M106.737,220.56l-.133-.077a1.685,1.685,0,0,1-.088.437l.122.131-.112.234-.122-.131a.906.906,0,0,1-.219.242l.094.163-.2.115-.094-.163a.957.957,0,0,1-.362.064l.05.172-.262-.031-.048-.169a1.717,1.717,0,0,1-.382-.138v.154l-.282-.163v-.154a3.059,3.059,0,0,1-.423-.344l-.053.11-.259-.277.053-.111a4.228,4.228,0,0,1-.32-.435l-.095.054-.2-.344.095-.054a4.078,4.078,0,0,1-.237-.552l-.124-.014-.1-.361.123.014a3.053,3.053,0,0,1-.07-.48l-.133-.077v-.324l.133.077a1.673,1.673,0,0,1,.088-.437l-.122-.132.112-.233.122.131a.91.91,0,0,1,.219-.243l-.094-.163.2-.114.094.163a.953.953,0,0,1,.362-.065l-.05-.171.262.031.049.169a1.743,1.743,0,0,1,.382.139v-.154l.282.163v.154a3.027,3.027,0,0,1,.423.344l.053-.111.259.278-.053.11a4.144,4.144,0,0,1,.32.436l.095-.054.2.343-.095.054a4.121,4.121,0,0,1,.237.552l.124.015.1.361-.123-.014a3.051,3.051,0,0,1,.07.48l.133.077Zm-1.9.1c.648.374,1.178.073,1.18-.672a2.587,2.587,0,0,0-1.172-2.03c-.648-.374-1.178-.073-1.18.672A2.587,2.587,0,0,0,104.842,220.656Z",
    transform: "translate(-102.953 -216.865)",
    fill: "#2d2f3c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61438",
    "data-name": "Group 61438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61437",
    "data-name": "Group 61437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61428",
    "data-name": "Group 61428",
    transform: "translate(0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61427",
    "data-name": "Group 61427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35442",
    "data-name": "Path 35442",
    d: "M51.361,175.45l1.393-.817.775-.442-1.393.817Z",
    transform: "translate(-51.361 -174.19)",
    fill: "#fc8b13"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61430",
    "data-name": "Group 61430",
    transform: "translate(9.627 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61429",
    "data-name": "Group 61429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35443",
    "data-name": "Path 35443",
    d: "M147.473,234.943l1.393-.817-.005,1.864-1.393.817Z",
    transform: "translate(-147.468 -234.126)",
    fill: "#f2b929"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61432",
    "data-name": "Group 61432",
    transform: "translate(8.862 4.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61431",
    "data-name": "Group 61431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35444",
    "data-name": "Path 35444",
    d: "M139.824,221.612l1.393-.817.771,1.335-1.393.817Z",
    transform: "translate(-139.824 -220.795)",
    fill: "#fed435"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61434",
    "data-name": "Group 61434",
    transform: "translate(0.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61433",
    "data-name": "Group 61433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35445",
    "data-name": "Path 35445",
    d: "M59.1,175.007l1.393-.817,8.081,4.666-1.393.817Z",
    transform: "translate(-59.102 -174.19)",
    fill: "#f2b929"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61436",
    "data-name": "Group 61436",
    transform: "translate(0 0.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61435",
    "data-name": "Group 61435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35446",
    "data-name": "Path 35446",
    d: "M60.171,187.02l.771,1.335-.005,1.864-.294-.17,0-1.724-.6-1.037-7.837-4.525-.6.343,0,1.724-.294-.17.005-1.864.775-.442Z",
    transform: "translate(-51.309 -182.354)",
    fill: "#fc8b13"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61525",
    "data-name": "Group 61525",
    transform: "translate(14.676 19.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61441",
    "data-name": "Group 61441",
    transform: "translate(0.294 0.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35447",
    "data-name": "Path 35447",
    d: "M194.537,261.269l1.393-.817.671,1.479-2.07,1.2Z",
    transform: "translate(-194.532 -260.452)",
    fill: "#b05f27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61512",
    "data-name": "Group 61512",
    transform: "translate(0.475 0.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61511",
    "data-name": "Group 61511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61443",
    "data-name": "Group 61443",
    transform: "translate(0.451 2.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61442",
    "data-name": "Group 61442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35448",
    "data-name": "Path 35448",
    d: "M200.835,294.015l1.291-.75.095-.054-1.291.751Z",
    transform: "translate(-200.835 -293.211)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61444",
    "data-name": "Group 61444",
    transform: "translate(1.269 4.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35449",
    "data-name": "Path 35449",
    d: "M209.065,304.515l1.291-.75-.053.11-1.291.751Z",
    transform: "translate(-209.012 -303.765)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61445",
    "data-name": "Group 61445",
    transform: "translate(0.081 2.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35450",
    "data-name": "Path 35450",
    d: "M197.141,284.7l1.291-.75.123.014-1.291.75Z",
    transform: "translate(-197.141 -283.951)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61446",
    "data-name": "Group 61446",
    transform: "translate(2.027 4.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35451",
    "data-name": "Path 35451",
    d: "M216.581,309.575l1.291-.751v.154l-1.291.75Z",
    transform: "translate(-216.581 -308.824)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61447",
    "data-name": "Group 61447",
    transform: "translate(0.001 1.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35452",
    "data-name": "Path 35452",
    d: "M196.338,276.051l1.291-.75.133.077-1.291.751Z",
    transform: "translate(-196.338 -275.301)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61449",
    "data-name": "Group 61449",
    transform: "translate(0.716 1.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61448",
    "data-name": "Group 61448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35453",
    "data-name": "Path 35453",
    d: "M204.775,281.042a2.587,2.587,0,0,0,1.172,2.031l-1.291.75a2.587,2.587,0,0,1-1.172-2.031Z",
    transform: "translate(-203.484 -281.042)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61450",
    "data-name": "Group 61450",
    transform: "translate(2.67 4.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35454",
    "data-name": "Path 35454",
    d: "M223,311.235l1.291-.75.05.172-1.291.75Z",
    transform: "translate(-223.003 -310.485)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61451",
    "data-name": "Group 61451",
    transform: "translate(0.212 0.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35455",
    "data-name": "Path 35455",
    d: "M198.45,268.815l1.291-.75.122.131-1.291.751Z",
    transform: "translate(-198.45 -268.065)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61453",
    "data-name": "Group 61453",
    transform: "translate(0.716 1.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61452",
    "data-name": "Group 61452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35456",
    "data-name": "Path 35456",
    d: "M205.119,273.522a.822.822,0,0,0-.343.753l-1.291.75a.822.822,0,0,1,.343-.753Z",
    transform: "translate(-203.484 -273.522)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61455",
    "data-name": "Group 61455",
    transform: "translate(1.888 3.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61454",
    "data-name": "Group 61454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35457",
    "data-name": "Path 35457",
    d: "M216.486,301.323a.829.829,0,0,0,.837.081l-1.291.75a.829.829,0,0,1-.836-.081Z",
    transform: "translate(-215.195 -301.323)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61457",
    "data-name": "Group 61457",
    transform: "translate(3.232 4.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61456",
    "data-name": "Group 61456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35458",
    "data-name": "Path 35458",
    d: "M228.611,309.452l1.291-.751.094.163-1.291.75Z",
    transform: "translate(-228.611 -308.701)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61459",
    "data-name": "Group 61459",
    transform: "translate(0.658 0.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61458",
    "data-name": "Group 61458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35459",
    "data-name": "Path 35459",
    d: "M202.908,264.934l1.291-.75.094.163L203,265.1Z",
    transform: "translate(-202.908 -264.184)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61461",
    "data-name": "Group 61461",
    transform: "translate(0.459 0.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61460",
    "data-name": "Group 61460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35460",
    "data-name": "Path 35460",
    d: "M200.915,265.048l1.291-.751.2-.114-1.291.75Z",
    transform: "translate(-200.915 -264.184)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61462",
    "data-name": "Group 61462",
    transform: "translate(3.231 4.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35461",
    "data-name": "Path 35461",
    d: "M228.829,307.032l1.291-.75a.907.907,0,0,1-.219.242l-1.291.751A.907.907,0,0,0,228.829,307.032Z",
    transform: "translate(-228.61 -306.282)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61463",
    "data-name": "Group 61463",
    transform: "translate(0.752 0.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35462",
    "data-name": "Path 35462",
    d: "M203.848,265.978l1.291-.75a.953.953,0,0,1,.362-.065l-1.291.751A.951.951,0,0,0,203.848,265.978Z",
    transform: "translate(-203.848 -265.163)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61465",
    "data-name": "Group 61465",
    transform: "translate(3.573 4.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61464",
    "data-name": "Group 61464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35463",
    "data-name": "Path 35463",
    d: "M232.136,306l1.291-.751-.112.234-1.291.751Z",
    transform: "translate(-232.024 -305.254)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61467",
    "data-name": "Group 61467",
    transform: "translate(3.563 4.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61466",
    "data-name": "Group 61466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35464",
    "data-name": "Path 35464",
    d: "M231.917,304.7l1.291-.751.122.131-1.291.751Z",
    transform: "translate(-231.917 -303.948)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61469",
    "data-name": "Group 61469",
    transform: "translate(2.725 3.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61468",
    "data-name": "Group 61468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35465",
    "data-name": "Path 35465",
    d: "M224.841,295.36l-1.291.75a.822.822,0,0,0,.343-.754l1.291-.751A.822.822,0,0,1,224.841,295.36Z",
    transform: "translate(-223.55 -294.606)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61471",
    "data-name": "Group 61471",
    transform: "translate(1.059 0.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61470",
    "data-name": "Group 61470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35466",
    "data-name": "Path 35466",
    d: "M206.913,273.558l1.291-.75a.83.83,0,0,1,.837.081l-1.291.75A.829.829,0,0,0,206.913,273.558Z",
    transform: "translate(-206.913 -272.728)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61473",
    "data-name": "Group 61473",
    transform: "translate(1.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61472",
    "data-name": "Group 61472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35467",
    "data-name": "Path 35467",
    d: "M206.968,264.2l1.291-.75.262.031-1.291.75Z",
    transform: "translate(-206.968 -263.452)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61475",
    "data-name": "Group 61475",
    transform: "translate(1.327 0.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61474",
    "data-name": "Group 61474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35468",
    "data-name": "Path 35468",
    d: "M209.589,264.514l1.291-.75.049.169-1.291.751Z",
    transform: "translate(-209.589 -263.764)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61476",
    "data-name": "Group 61476",
    transform: "translate(3.563 3.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35469",
    "data-name": "Path 35469",
    d: "M232,300.337l1.291-.75a1.69,1.69,0,0,1-.088.437l-1.291.75A1.685,1.685,0,0,0,232,300.337Z",
    transform: "translate(-231.917 -299.587)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61477",
    "data-name": "Group 61477",
    transform: "translate(1.376 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35470",
    "data-name": "Path 35470",
    d: "M210.076,266.2l1.291-.75a1.743,1.743,0,0,1,.382.139l-1.291.75A1.745,1.745,0,0,0,210.076,266.2Z",
    transform: "translate(-210.076 -265.453)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61479",
    "data-name": "Group 61479",
    transform: "translate(0.716 1.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61478",
    "data-name": "Group 61478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35471",
    "data-name": "Path 35471",
    d: "M205.838,282.419a.973.973,0,0,1-.172.6c-.208.272-.583.318-1.008.072a2.585,2.585,0,0,1-1.173-2.03c0-.52.26-.825.638-.832a1.057,1.057,0,0,1,.542.16A2.588,2.588,0,0,1,205.838,282.419Z",
    transform: "translate(-203.485 -280.228)",
    fill: "#f2b929"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61481",
    "data-name": "Group 61481",
    transform: "translate(1.182 1.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61480",
    "data-name": "Group 61480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35472",
    "data-name": "Path 35472",
    d: "M210.021,282.418a.973.973,0,0,1-.172.6,1.057,1.057,0,0,1-.542-.16,2.588,2.588,0,0,1-1.173-2.031.972.972,0,0,1,.172-.6,1.057,1.057,0,0,1,.542.16A2.589,2.589,0,0,1,210.021,282.418Z",
    transform: "translate(-208.134 -280.227)",
    fill: "#fc8b13"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61483",
    "data-name": "Group 61483",
    transform: "translate(1.896 1.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61482",
    "data-name": "Group 61482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35473",
    "data-name": "Path 35473",
    d: "M215.271,275.084l1.291-.75a2.587,2.587,0,0,1,1.172,2.03l-1.291.751A2.587,2.587,0,0,0,215.271,275.084Z",
    transform: "translate(-215.271 -274.334)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61485",
    "data-name": "Group 61485",
    transform: "translate(3.651 3.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61484",
    "data-name": "Group 61484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35474",
    "data-name": "Path 35474",
    d: "M232.8,297.106l1.291-.751.133.077-1.291.751Z",
    transform: "translate(-232.805 -296.355)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61487",
    "data-name": "Group 61487",
    transform: "translate(3.784 3.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61486",
    "data-name": "Group 61486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35475",
    "data-name": "Path 35475",
    d: "M234.129,297.875l1.291-.751v.324l-1.291.75Z",
    transform: "translate(-234.128 -297.124)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61489",
    "data-name": "Group 61489",
    transform: "translate(1.758 0.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61488",
    "data-name": "Group 61488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35476",
    "data-name": "Path 35476",
    d: "M213.892,266.048l1.291-.75.282.163-1.291.751Z",
    transform: "translate(-213.892 -265.298)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61491",
    "data-name": "Group 61491",
    transform: "translate(2.039 0.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61490",
    "data-name": "Group 61490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35477",
    "data-name": "Path 35477",
    d: "M216.7,267.672l1.291-.751v.154l-1.291.75Z",
    transform: "translate(-216.7 -266.921)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61492",
    "data-name": "Group 61492",
    transform: "translate(3.581 2.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35478",
    "data-name": "Path 35478",
    d: "M232.1,292.314l1.291-.75a3.037,3.037,0,0,1,.07.48l-1.291.75A3.041,3.041,0,0,0,232.1,292.314Z",
    transform: "translate(-232.1 -291.564)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61494",
    "data-name": "Group 61494",
    transform: "translate(2.039 0.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61493",
    "data-name": "Group 61493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35479",
    "data-name": "Path 35479",
    d: "M216.7,269.211l1.291-.75a3.032,3.032,0,0,1,.423.344l-1.291.75A3.03,3.03,0,0,0,216.7,269.211Z",
    transform: "translate(-216.7 -268.461)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61495",
    "data-name": "Group 61495",
    transform: "translate(3.239 1.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35480",
    "data-name": "Path 35480",
    d: "M228.685,283.188l1.291-.75a4.126,4.126,0,0,1,.237.552l-1.291.75A4.119,4.119,0,0,0,228.685,283.188Z",
    transform: "translate(-228.685 -282.438)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61496",
    "data-name": "Group 61496",
    transform: "translate(2.721 1.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35481",
    "data-name": "Path 35481",
    d: "M223.51,275.4l1.291-.75a4.147,4.147,0,0,1,.32.436l-1.291.751A4.126,4.126,0,0,0,223.51,275.4Z",
    transform: "translate(-223.51 -274.653)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61498",
    "data-name": "Group 61498",
    transform: "translate(3.476 2.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61497",
    "data-name": "Group 61497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35482",
    "data-name": "Path 35482",
    d: "M231.049,288.7l1.291-.751.124.015-1.291.75Z",
    transform: "translate(-231.049 -287.953)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61500",
    "data-name": "Group 61500",
    transform: "translate(3.6 2.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61499",
    "data-name": "Group 61499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35483",
    "data-name": "Path 35483",
    d: "M232.29,288.855l1.291-.75.1.361-1.291.751Z",
    transform: "translate(-232.29 -288.105)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61502",
    "data-name": "Group 61502",
    transform: "translate(2.721 1.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61501",
    "data-name": "Group 61501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35484",
    "data-name": "Path 35484",
    d: "M223.563,274.308l1.291-.751-.053.11-1.291.751Z",
    transform: "translate(-223.51 -273.557)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61504",
    "data-name": "Group 61504",
    transform: "translate(2.515 0.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61503",
    "data-name": "Group 61503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35485",
    "data-name": "Path 35485",
    d: "M221.453,271.534l1.291-.75.259.278-1.291.751Z",
    transform: "translate(-221.453 -270.784)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61506",
    "data-name": "Group 61506",
    transform: "translate(3.041 1.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61505",
    "data-name": "Group 61505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35486",
    "data-name": "Path 35486",
    d: "M226.705,279.272l1.291-.751.095-.054-1.291.751Z",
    transform: "translate(-226.705 -278.468)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61508",
    "data-name": "Group 61508",
    transform: "translate(3.135 1.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61507",
    "data-name": "Group 61507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35487",
    "data-name": "Path 35487",
    d: "M227.651,279.219l1.291-.751.2.343-1.291.751Z",
    transform: "translate(-227.651 -278.468)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61510",
    "data-name": "Group 61510",
    transform: "translate(0 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61509",
    "data-name": "Group 61509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35488",
    "data-name": "Path 35488",
    d: "M200.116,274.642l-.133-.077a1.688,1.688,0,0,1-.088.437l.122.131-.112.234-.122-.131a.906.906,0,0,1-.219.242l.094.163-.2.115-.094-.163a.958.958,0,0,1-.362.064l.05.172-.262-.031-.048-.169a1.711,1.711,0,0,1-.382-.138v.154l-.282-.163v-.154a3.071,3.071,0,0,1-.423-.344l-.053.11-.259-.277.053-.111a4.229,4.229,0,0,1-.32-.435l-.095.054-.2-.344.095-.054a4.072,4.072,0,0,1-.237-.552l-.124-.014-.1-.361.123.014a3.055,3.055,0,0,1-.07-.48l-.133-.077v-.324l.133.077a1.671,1.671,0,0,1,.088-.437l-.122-.132.112-.233.122.131a.911.911,0,0,1,.219-.243l-.094-.163.2-.114.094.163a.952.952,0,0,1,.362-.065l-.049-.171.262.031.049.169a1.744,1.744,0,0,1,.382.139v-.154l.282.163v.154a3.029,3.029,0,0,1,.423.344l.053-.111.259.278-.053.11a4.147,4.147,0,0,1,.32.436l.095-.054.2.343-.095.054a4.124,4.124,0,0,1,.237.552l.124.015.1.361-.123-.014a3.054,3.054,0,0,1,.07.48l.133.077Zm-1.9.1c.648.374,1.178.073,1.18-.672a2.587,2.587,0,0,0-1.172-2.03c-.648-.374-1.178-.073-1.18.671A2.587,2.587,0,0,0,198.22,274.739Z",
    transform: "translate(-196.332 -270.947)",
    fill: "#2d2f3c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61524",
    "data-name": "Group 61524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61523",
    "data-name": "Group 61523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61514",
    "data-name": "Group 61514",
    transform: "translate(0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61513",
    "data-name": "Group 61513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35489",
    "data-name": "Path 35489",
    d: "M191.644,255.595l1.393-.817.775-.442-1.393.817Z",
    transform: "translate(-191.644 -254.335)",
    fill: "#fc8b13"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61516",
    "data-name": "Group 61516",
    transform: "translate(4.829 3.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61515",
    "data-name": "Group 61515"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35490",
    "data-name": "Path 35490",
    d: "M239.832,287.42l1.393-.817-.005,1.864-1.393.817Z",
    transform: "translate(-239.827 -286.603)",
    fill: "#f2b929"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61518",
    "data-name": "Group 61518",
    transform: "translate(4.064 1.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61517",
    "data-name": "Group 61517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35491",
    "data-name": "Path 35491",
    d: "M232.183,274.088l1.393-.817.771,1.335-1.393.817Z",
    transform: "translate(-232.183 -273.271)",
    fill: "#fed435"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61520",
    "data-name": "Group 61520",
    transform: "translate(0.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61519",
    "data-name": "Group 61519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35492",
    "data-name": "Path 35492",
    d: "M199.385,255.152l1.393-.817,3.284,1.9-1.393.817Z",
    transform: "translate(-199.385 -254.335)",
    fill: "#f2b929"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61522",
    "data-name": "Group 61522",
    transform: "translate(0 0.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61521",
    "data-name": "Group 61521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35493",
    "data-name": "Path 35493",
    d: "M195.656,264.395l.771,1.335-.005,1.864-.294-.17,0-1.724-.6-1.036-3.039-1.755-.6.343,0,1.724-.294-.17.005-1.864.775-.442Z",
    transform: "translate(-191.592 -262.499)",
    fill: "#fc8b13"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61555",
    "data-name": "Group 61555",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61533",
    "data-name": "Group 61533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61532",
    "data-name": "Group 61532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61526",
    "data-name": "Group 61526",
    transform: "translate(1.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35494",
    "data-name": "Path 35494",
    d: "M57,65.2l6.532-3.8L81.893,72.029l-6.532,3.8Z",
    transform: "translate(-57 -61.402)",
    fill: "#f2b929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35495",
    "data-name": "Path 35495",
    d: "M112.047,119.884l-1.427.83-12.17-7.053-2.267-1.309,1.425-.83,1.235.712Z",
    transform: "translate(-92.26 -106.505)",
    fill: "#f0ab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35496",
    "data-name": "Path 35496",
    d: "M65.652,68.344l.017.009-1.425.83-1.731-1L60.69,67.132l6.163-3.581-1.188,2.8-.006.015Z",
    transform: "translate(-60.321 -63.336)",
    fill: "#f0ab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35497",
    "data-name": "Path 35497",
    d: "M82.047,93.529l-1.425.83-1.731-1,3.153-1.833-.006.015L82.03,93.52Z",
    transform: "translate(-76.699 -88.511)",
    fill: "#f2b929"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61527",
    "data-name": "Group 61527",
    transform: "translate(20.051 9.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35498",
    "data-name": "Path 35498",
    d: "M246.028,159.415l6.532-3.8-.75,6.966-6.532,3.8Z",
    transform: "translate(-245.278 -155.619)",
    fill: "#f0ab00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61529",
    "data-name": "Group 61529",
    transform: "translate(6.533 0.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61528",
    "data-name": "Group 61528",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35499",
    "data-name": "Path 35499",
    d: "M129.445,73.965l-3.865,2.245a1.74,1.74,0,0,1-1.744,0l-13.583-7.867.007-1.978,1.194-2.816Z",
    transform: "translate(-110.254 -63.552)",
    fill: "#fc8b13"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61531",
    "data-name": "Group 61531",
    transform: "translate(0 3.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61530",
    "data-name": "Group 61530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35500",
    "data-name": "Path 35500",
    d: "M67.125,108.666v.484l-1.323-.4-.75,6.966L45,104.115l.006-1.977,1.2-2.818,18.361,10.627.8-2.3Z",
    transform: "translate(-45 -99.319)",
    fill: "#fc8b13"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61547",
    "data-name": "Group 61547",
    transform: "translate(0.62 4.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61546",
    "data-name": "Group 61546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61534",
    "data-name": "Group 61534",
    transform: "translate(0.133 2.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35501",
    "data-name": "Path 35501",
    d: "M52.525,132.811l.039-.023,0,.99-.039.023Z",
    transform: "translate(-52.522 -132.788)",
    fill: "#f0ab00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61535",
    "data-name": "Group 61535",
    transform: "translate(0.136 0.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35502",
    "data-name": "Path 35502",
    d: "M53.222,116.971l.039-.023-.672,1.586-.039.023Z",
    transform: "translate(-52.55 -116.948)",
    fill: "#f0ab00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61536",
    "data-name": "Group 61536",
    transform: "translate(0.859 0.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35503",
    "data-name": "Path 35503",
    d: "M60.016,110.078l.039-.023-.242.568-.039.023Z",
    transform: "translate(-59.774 -110.055)",
    fill: "#f0ab00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61538",
    "data-name": "Group 61538",
    transform: "translate(0.133 3.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61537",
    "data-name": "Group 61537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35504",
    "data-name": "Path 35504",
    d: "M52.522,142.7l.039-.023,18.6,10.767-.039.023Z",
    transform: "translate(-52.522 -142.676)",
    fill: "#fed435"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61540",
    "data-name": "Group 61540",
    transform: "translate(0.859 0.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61539",
    "data-name": "Group 61539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35505",
    "data-name": "Path 35505",
    d: "M59.774,115.756l.039-.023L77.7,126.085l-.039.023Z",
    transform: "translate(-59.774 -115.733)",
    fill: "#fed435"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61542",
    "data-name": "Group 61542",
    transform: "translate(1.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61541",
    "data-name": "Group 61541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35506",
    "data-name": "Path 35506",
    d: "M61.3,108.052l.039-.023L79.2,118.37l-.039.023Z",
    transform: "translate(-61.299 -108.029)",
    fill: "#fed435"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61543",
    "data-name": "Group 61543",
    transform: "translate(18.867 10.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35507",
    "data-name": "Path 35507",
    d: "M239.662,211.348l.039-.023-.011,4.121-.039.023Z",
    transform: "translate(-239.651 -211.325)",
    fill: "#f0ab00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61545",
    "data-name": "Group 61545",
    transform: "translate(0 0.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61544",
    "data-name": "Group 61544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35508",
    "data-name": "Path 35508",
    d: "M70.072,118.6l-.011,4.121L51.194,111.8l.008-1.179,1-2.364Zm-18.745-6.873,18.6,10.767.007-2.961L52,109.149l-.672,1.586Zm.968-3.266-.242.568L69.938,119.38l0-.707Z",
    transform: "translate(-51.194 -108.256)",
    fill: "#f2b929"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61550",
    "data-name": "Group 61550",
    transform: "translate(24.213 10.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61548",
    "data-name": "Group 61548",
    transform: "translate(0 3.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35509",
    "data-name": "Path 35509",
    d: "M287.859,197.522v5.964a.248.248,0,0,1-.146.2.779.779,0,0,1-.706,0,.248.248,0,0,1-.146-.2v-5.964Z",
    transform: "translate(-286.861 -197.234)",
    fill: "#5e5e6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35510",
    "data-name": "Path 35510",
    d: "M287.014,197.522l-.007.2v5.964a.248.248,0,0,1-.146-.2v-5.964h.154Z",
    transform: "translate(-286.86 -197.234)",
    fill: "#393b47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35511",
    "data-name": "Path 35511",
    d: "M287.711,194.727a.215.215,0,0,1,0,.408.78.78,0,0,1-.706,0,.215.215,0,0,1,0-.408.78.78,0,0,1,.706,0Z",
    transform: "translate(-286.859 -194.643)",
    fill: "#4e4d58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61549",
    "data-name": "Group 61549",
    transform: "translate(0.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35512",
    "data-name": "Path 35512",
    d: "M288.673,161.423v3.589a.2.2,0,0,1-.116.162.62.62,0,0,1-.562,0,.2.2,0,0,1-.116-.162v-3.589Z",
    transform: "translate(-287.879 -161.423)",
    fill: "#5e5e6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35513",
    "data-name": "Path 35513",
    d: "M288,161.423l-.006.162v3.589a.2.2,0,0,1-.116-.162v-3.589Z",
    transform: "translate(-287.879 -161.423)",
    fill: "#393b47"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61552",
    "data-name": "Group 61552",
    transform: "translate(22.124 9.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61551",
    "data-name": "Group 61551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35514",
    "data-name": "Path 35514",
    d: "M265.985,158.562l6.532-3.8v.484l-6.532,3.8Z",
    transform: "translate(-265.984 -154.766)",
    fill: "#fed435"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61554",
    "data-name": "Group 61554",
    transform: "translate(20.362 8.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61553",
    "data-name": "Group 61553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35515",
    "data-name": "Path 35515",
    d: "M248.384,148.393l6.532-3.8,1.763,1.018-6.532,3.8Z",
    transform: "translate(-248.384 -144.597)",
    fill: "#f2b929"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61599",
    "data-name": "Group 61599",
    transform: "translate(22.401 12.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61566",
    "data-name": "Group 61566",
    transform: "translate(12.33 4.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61564",
    "data-name": "Group 61564",
    transform: "translate(0.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61563",
    "data-name": "Group 61563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61556",
    "data-name": "Group 61556",
    transform: "translate(0.002 1.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35516",
    "data-name": "Path 35516",
    d: "M395.517,240.111l-.138-.08a.293.293,0,0,1-.122-.269l.138.08A.293.293,0,0,0,395.517,240.111Z",
    transform: "translate(-395.257 -239.762)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61557",
    "data-name": "Group 61557",
    transform: "translate(0 0.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35517",
    "data-name": "Path 35517",
    d: "M395.377,233.453l-.138-.08,0-.711.138.08Z",
    transform: "translate(-395.237 -232.662)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61559",
    "data-name": "Group 61559",
    transform: "translate(0.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61558",
    "data-name": "Group 61558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35518",
    "data-name": "Path 35518",
    d: "M399.7,224.9l.138.08a.3.3,0,0,0-.3.029l-.138-.08A.3.3,0,0,1,399.7,224.9Z",
    transform: "translate(-399.405 -224.867)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61560",
    "data-name": "Group 61560",
    transform: "translate(0 0.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35519",
    "data-name": "Path 35519",
    d: "M395.375,226.243l-.138-.08a.92.92,0,0,1,.417-.723l.138.08A.92.92,0,0,0,395.375,226.243Z",
    transform: "translate(-395.237 -225.44)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61562",
    "data-name": "Group 61562",
    transform: "translate(0.138 0.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61561",
    "data-name": "Group 61561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35520",
    "data-name": "Path 35520",
    d: "M397.032,225.726c.231-.133.419-.026.42.239l0,.711a.92.92,0,0,1-.417.723c-.231.134-.419.026-.42-.239l0-.711A.919.919,0,0,1,397.032,225.726Z",
    transform: "translate(-396.615 -225.669)",
    fill: "#5e5e6a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61565",
    "data-name": "Group 61565",
    transform: "translate(0 0.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35521",
    "data-name": "Path 35521",
    d: "M391.963,232.875a.04.04,0,0,1-.035.006c-.019-.008-.019-.039,0-.069l.576-.9a.455.455,0,0,0,.078-.232v-.352c0-.145-.118-.195-.263-.111l-.356.206c-.027.016-.049.006-.049-.021a.1.1,0,0,1,.049-.077l.356-.206c.2-.115.361-.047.361.152v.352a.626.626,0,0,1-.107.318l-.576.9A.1.1,0,0,1,391.963,232.875Z",
    transform: "translate(-391.914 -231.06)",
    fill: "#393b47"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61575",
    "data-name": "Group 61575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61572",
    "data-name": "Group 61572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61568",
    "data-name": "Group 61568",
    transform: "translate(0.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61567",
    "data-name": "Group 61567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35522",
    "data-name": "Path 35522",
    d: "M269.933,186.637l6.389-3.712a.219.219,0,0,1,.221.022l-6.39,3.712A.219.219,0,0,0,269.933,186.637Z",
    transform: "translate(-269.933 -182.905)",
    fill: "#f2b929"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61570",
    "data-name": "Group 61570",
    transform: "translate(0.339 0.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61569",
    "data-name": "Group 61569"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35523",
    "data-name": "Path 35523",
    d: "M272.141,187.042l6.389-3.712,4.759,2.73-6.389,3.712Z",
    transform: "translate(-272.141 -183.33)",
    fill: "#f2b929"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_35524",
    "data-name": "Path 35524",
    d: "M327.155,215.2s-.009,1.724-.009,1.724l-.008,1.721-3.195,1.856-3.195,1.856.009-1.721.008-1.721c0-.367-.013-.743-.044-1.127s-.08-.776-.147-1.175a10.753,10.753,0,0,0-.238-1.092c0-.016-.008-.031-.013-.047-.028-.1-.058-.189-.088-.278a2.766,2.766,0,0,0-.3-.63q-.019-.028-.038-.053a.8.8,0,0,0-.226-.211l3.194-1.856,3.195-1.856a.785.785,0,0,1,.226.211q.019.025.038.053a2.715,2.715,0,0,1,.3.631c.03.089.06.181.087.277,0,.015.009.03.013.046a10.222,10.222,0,0,1,.24,1.093q.1.6.146,1.175T327.155,215.2Z",
    transform: "translate(-314.578 -207.822)",
    fill: "#f2b929"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61571",
    "data-name": "Group 61571",
    transform: "translate(0 3.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35525",
    "data-name": "Path 35525",
    d: "M273.856,222.752c.458.264.738,1.351.9,2.312a13.685,13.685,0,0,1,.191,2.3l-.017,3.442-6.172-3.547.027-7.061c0-.2.14-.276.312-.178Z",
    transform: "translate(-268.759 -219.979)",
    fill: "#fc8b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35526",
    "data-name": "Path 35526",
    d: "M293.352,239.17l-.012-4.3,2.539,1.452c.145.084.516.465.8,2.175a13.515,13.515,0,0,1,.189,2.268v.428Z",
    transform: "translate(-290.879 -233.378)",
    fill: "#299ab9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61574",
    "data-name": "Group 61574",
    transform: "translate(5.324 2.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61573",
    "data-name": "Group 61573"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35527",
    "data-name": "Path 35527",
    d: "M328.758,213.715l-6.388,3.713c0-.016-.008-.031-.013-.047-.028-.1-.058-.189-.088-.278a2.765,2.765,0,0,0-.3-.63q-.019-.028-.038-.053l6.389-3.712.038.053a2.718,2.718,0,0,1,.3.631c.03.089.06.181.087.277C328.75,213.684,328.754,213.7,328.758,213.715Z",
    transform: "translate(-321.934 -212.708)",
    fill: "#fed435"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61583",
    "data-name": "Group 61583",
    transform: "translate(7.545 9.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61576",
    "data-name": "Group 61576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35528",
    "data-name": "Path 35528",
    d: "M344.126,278.156l3.848-2.232v1.641l-3.848,2.232Z",
    transform: "translate(-344.126 -275.924)",
    fill: "#5e5e6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35529",
    "data-name": "Path 35529",
    d: "M349.02,290.644l-3.587,2.081v-.232l3.363-1.952Z",
    transform: "translate(-345.302 -289.078)",
    fill: "#2d2f3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35530",
    "data-name": "Path 35530",
    d: "M348.8,279.479v1.107l-3.363,1.952v-1.107Z",
    transform: "translate(-345.302 -279.123)",
    fill: "#2d2f3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35531",
    "data-name": "Path 35531",
    d: "M379.25,278.182v1.34l-.223-.1v-1.107Z",
    transform: "translate(-375.533 -277.956)",
    fill: "#2d2f3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61582",
    "data-name": "Group 61582",
    transform: "translate(0.064 0.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61581",
    "data-name": "Group 61581",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61577",
    "data-name": "Group 61577",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21428",
    "data-name": "Rectangle 21428",
    width: 4.245,
    height: 0.098,
    transform: "translate(0 2.13) rotate(-30.124)",
    fill: "#5e5e6a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61578",
    "data-name": "Group 61578",
    transform: "translate(0 0.27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21429",
    "data-name": "Rectangle 21429",
    width: 4.245,
    height: 0.098,
    transform: "matrix(0.865, -0.502, 0.502, 0.865, 0, 2.13)",
    fill: "#5e5e6a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61579",
    "data-name": "Group 61579",
    transform: "translate(0.003 0.538)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21430",
    "data-name": "Rectangle 21430",
    width: 4.245,
    height: 0.098,
    transform: "translate(0 2.13) rotate(-30.124)",
    fill: "#5e5e6a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61580",
    "data-name": "Group 61580",
    transform: "translate(0.003 0.807)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21431",
    "data-name": "Rectangle 21431",
    width: 4.245,
    height: 0.098,
    transform: "translate(0 2.13) rotate(-30.124)",
    fill: "#5e5e6a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61585",
    "data-name": "Group 61585",
    transform: "translate(6.455 12.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61584",
    "data-name": "Group 61584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35532",
    "data-name": "Path 35532",
    d: "M333.491,307.671c-.155,0-.251-.109-.251-.286a.97.97,0,0,1,.466-.737.49.49,0,0,1,.238-.073c.154,0,.251.109.251.285a.97.97,0,0,1-.466.737A.488.488,0,0,1,333.491,307.671Z",
    transform: "translate(-333.24 -306.575)",
    fill: "#fed435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35533",
    "data-name": "Path 35533",
    d: "M334.378,307.068a.943.943,0,0,1-.455.717c-.251.145-.455.059-.455-.192a.943.943,0,0,1,.455-.717C334.175,306.73,334.378,306.817,334.378,307.068Z",
    transform: "translate(-333.446 -306.782)",
    fill: "#5e5e6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35534",
    "data-name": "Path 35534",
    d: "M334.539,308.6c-.111,0-.134-.092-.134-.169a.854.854,0,0,1,.408-.636.376.376,0,0,1,.18-.058c.111,0,.134.092.134.169a.854.854,0,0,1-.408.636A.375.375,0,0,1,334.539,308.6Z",
    transform: "translate(-334.288 -307.624)",
    fill: "#ffefd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35535",
    "data-name": "Path 35535",
    d: "M335.413,307.794a.192.192,0,0,1,.042.135.854.854,0,0,1-.408.636.376.376,0,0,1-.18.058.157.157,0,0,1-.041-.005.122.122,0,0,0,.092.034.376.376,0,0,0,.18-.058.854.854,0,0,0,.408-.636C335.507,307.891,335.489,307.814,335.413,307.794Z",
    transform: "translate(-334.668 -307.672)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61587",
    "data-name": "Group 61587",
    transform: "translate(11.508 9.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61586",
    "data-name": "Group 61586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35536",
    "data-name": "Path 35536",
    d: "M383.96,278.331c-.155,0-.251-.109-.251-.286a.97.97,0,0,1,.466-.737.49.49,0,0,1,.238-.074c.155,0,.251.109.251.285a.97.97,0,0,1-.466.737A.489.489,0,0,1,383.96,278.331Z",
    transform: "translate(-383.709 -277.235)",
    fill: "#fed435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35537",
    "data-name": "Path 35537",
    d: "M384.847,277.727a.943.943,0,0,1-.455.717c-.251.145-.455.059-.455-.192a.943.943,0,0,1,.455-.717C384.644,277.389,384.847,277.476,384.847,277.727Z",
    transform: "translate(-383.915 -277.441)",
    fill: "#5e5e6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35538",
    "data-name": "Path 35538",
    d: "M385.008,279.263c-.111,0-.134-.092-.134-.169a.854.854,0,0,1,.408-.636.376.376,0,0,1,.18-.058c.111,0,.134.092.134.169a.854.854,0,0,1-.408.636A.376.376,0,0,1,385.008,279.263Z",
    transform: "translate(-384.757 -278.283)",
    fill: "#ffefd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35539",
    "data-name": "Path 35539",
    d: "M385.883,278.453a.192.192,0,0,1,.042.135.854.854,0,0,1-.408.636.376.376,0,0,1-.18.058.157.157,0,0,1-.041-.005.123.123,0,0,0,.092.034.376.376,0,0,0,.18-.058.854.854,0,0,0,.408-.636C385.977,278.55,385.959,278.473,385.883,278.453Z",
    transform: "translate(-385.138 -278.331)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61598",
    "data-name": "Group 61598",
    transform: "translate(4.413 8.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61596",
    "data-name": "Group 61596",
    transform: "translate(0 0.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61595",
    "data-name": "Group 61595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61588",
    "data-name": "Group 61588",
    transform: "translate(0.002 1.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35540",
    "data-name": "Path 35540",
    d: "M313.12,286.233l-.138-.08a.293.293,0,0,1-.122-.269l.138.08A.293.293,0,0,0,313.12,286.233Z",
    transform: "translate(-312.86 -285.884)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61589",
    "data-name": "Group 61589",
    transform: "translate(0 0.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35541",
    "data-name": "Path 35541",
    d: "M312.979,279.575l-.138-.08,0-.711.138.08Z",
    transform: "translate(-312.839 -278.784)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61591",
    "data-name": "Group 61591",
    transform: "translate(0.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61590",
    "data-name": "Group 61590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35542",
    "data-name": "Path 35542",
    d: "M317.306,271.017l.138.08a.3.3,0,0,0-.3.029l-.138-.08A.3.3,0,0,1,317.306,271.017Z",
    transform: "translate(-317.008 -270.989)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61592",
    "data-name": "Group 61592",
    transform: "translate(0 0.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35543",
    "data-name": "Path 35543",
    d: "M312.978,272.366l-.138-.08a.92.92,0,0,1,.417-.723l.138.08A.92.92,0,0,0,312.978,272.366Z",
    transform: "translate(-312.84 -271.563)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61594",
    "data-name": "Group 61594",
    transform: "translate(0.138 0.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61593",
    "data-name": "Group 61593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35544",
    "data-name": "Path 35544",
    d: "M314.634,271.848c.231-.133.419-.026.42.239l0,.711a.92.92,0,0,1-.417.723c-.231.134-.419.026-.42-.239l0-.711A.92.92,0,0,1,314.634,271.848Z",
    transform: "translate(-314.217 -271.791)",
    fill: "#5e5e6a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61597",
    "data-name": "Group 61597",
    transform: "translate(0.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35545",
    "data-name": "Path 35545",
    d: "M321.282,271.63a.105.105,0,0,0,.035-.035c.019-.03.019-.061,0-.069l-.678-.28a.142.142,0,0,1-.078-.142v-.352a.546.546,0,0,1,.263-.415l.356-.206a.1.1,0,0,0,.049-.077c0-.027-.022-.036-.049-.021l-.356.206a.75.75,0,0,0-.361.569v.352a.2.2,0,0,0,.107.195l.678.28A.04.04,0,0,0,321.282,271.63Z",
    transform: "translate(-320.462 -270.027)",
    fill: "#393b47"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_35546",
    "data-name": "Path 35546",
    d: "M328.117,229.254c-.006-.271-.02-.541-.041-.806-.032-.388-.082-.789-.149-1.191a10.007,10.007,0,0,0-.3-1.3l6.042-3.509a9.911,9.911,0,0,1,.258,1.158c.064.383.112.773.144,1.158.028.337.042.675.044,1C333.567,226.106,330.41,227.932,328.117,229.254Z",
    transform: "translate(-321.736 -218.494)",
    fill: "#7cc3d5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61684",
    "data-name": "Group 61684",
    transform: "translate(20.073 22.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61600",
    "data-name": "Group 61600",
    transform: "translate(0.294 0.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35547",
    "data-name": "Path 35547",
    d: "M248.452,292.165l1.393-.817.671,1.479-2.07,1.2Z",
    transform: "translate(-248.447 -291.348)",
    fill: "#b05f27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61671",
    "data-name": "Group 61671",
    transform: "translate(0.474 0.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61670",
    "data-name": "Group 61670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61602",
    "data-name": "Group 61602",
    transform: "translate(0.451 2.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61601",
    "data-name": "Group 61601"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35548",
    "data-name": "Path 35548",
    d: "M254.75,324.912l1.291-.751.095-.054-1.291.75Z",
    transform: "translate(-254.75 -324.108)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61603",
    "data-name": "Group 61603",
    transform: "translate(1.27 4.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35549",
    "data-name": "Path 35549",
    d: "M262.98,335.411l1.291-.75-.053.11-1.291.75Z",
    transform: "translate(-262.927 -334.661)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61604",
    "data-name": "Group 61604",
    transform: "translate(0.081 2.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35550",
    "data-name": "Path 35550",
    d: "M251.055,315.6l1.291-.751.123.014-1.291.751Z",
    transform: "translate(-251.055 -314.847)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61605",
    "data-name": "Group 61605",
    transform: "translate(2.028 4.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35551",
    "data-name": "Path 35551",
    d: "M270.5,340.471l1.291-.75v.154l-1.291.751Z",
    transform: "translate(-270.496 -339.721)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61606",
    "data-name": "Group 61606",
    transform: "translate(0.001 1.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35552",
    "data-name": "Path 35552",
    d: "M250.253,306.948l1.291-.751.133.077-1.291.75Z",
    transform: "translate(-250.253 -306.197)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61608",
    "data-name": "Group 61608",
    transform: "translate(0.716 1.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61607",
    "data-name": "Group 61607"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35553",
    "data-name": "Path 35553",
    d: "M258.691,311.938a2.588,2.588,0,0,0,1.172,2.031l-1.291.75a2.587,2.587,0,0,1-1.172-2.031Z",
    transform: "translate(-257.4 -311.938)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61609",
    "data-name": "Group 61609",
    transform: "translate(2.67 4.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35554",
    "data-name": "Path 35554",
    d: "M276.918,342.132l1.291-.751.05.172-1.291.751Z",
    transform: "translate(-276.918 -341.381)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61610",
    "data-name": "Group 61610",
    transform: "translate(0.212 0.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35555",
    "data-name": "Path 35555",
    d: "M252.365,299.712l1.291-.751.122.131-1.291.75Z",
    transform: "translate(-252.365 -298.961)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61612",
    "data-name": "Group 61612",
    transform: "translate(0.716 1.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61611",
    "data-name": "Group 61611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35556",
    "data-name": "Path 35556",
    d: "M259.035,304.418a.822.822,0,0,0-.343.753l-1.291.75a.822.822,0,0,1,.343-.753Z",
    transform: "translate(-257.4 -304.418)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61614",
    "data-name": "Group 61614",
    transform: "translate(1.889 3.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61613",
    "data-name": "Group 61613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35557",
    "data-name": "Path 35557",
    d: "M270.4,332.22a.829.829,0,0,0,.837.081l-1.291.75a.829.829,0,0,1-.837-.081Z",
    transform: "translate(-269.109 -332.22)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61616",
    "data-name": "Group 61616",
    transform: "translate(3.232 4.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61615",
    "data-name": "Group 61615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35558",
    "data-name": "Path 35558",
    d: "M282.526,340.348l1.291-.75.094.163-1.291.75Z",
    transform: "translate(-282.526 -339.598)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61618",
    "data-name": "Group 61618",
    transform: "translate(0.659 0.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61617",
    "data-name": "Group 61617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35559",
    "data-name": "Path 35559",
    d: "M256.823,295.83l1.291-.75.094.163-1.291.751Z",
    transform: "translate(-256.823 -295.08)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61620",
    "data-name": "Group 61620",
    transform: "translate(0.459 0.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61619",
    "data-name": "Group 61619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35560",
    "data-name": "Path 35560",
    d: "M254.83,295.944l1.291-.75.2-.114-1.291.75Z",
    transform: "translate(-254.83 -295.08)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61621",
    "data-name": "Group 61621",
    transform: "translate(3.232 4.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35561",
    "data-name": "Path 35561",
    d: "M282.744,337.928l1.291-.751a.906.906,0,0,1-.219.242l-1.291.75A.9.9,0,0,0,282.744,337.928Z",
    transform: "translate(-282.525 -337.177)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61622",
    "data-name": "Group 61622",
    transform: "translate(0.753 0.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35562",
    "data-name": "Path 35562",
    d: "M257.763,296.875l1.291-.75a.953.953,0,0,1,.362-.065l-1.291.75A.952.952,0,0,0,257.763,296.875Z",
    transform: "translate(-257.763 -296.06)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61624",
    "data-name": "Group 61624",
    transform: "translate(3.574 4.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61623",
    "data-name": "Group 61623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35563",
    "data-name": "Path 35563",
    d: "M286.051,336.9l1.291-.75-.112.234-1.291.75Z",
    transform: "translate(-285.939 -336.151)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61626",
    "data-name": "Group 61626",
    transform: "translate(3.563 4.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61625",
    "data-name": "Group 61625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35564",
    "data-name": "Path 35564",
    d: "M285.832,335.6l1.291-.75.122.131-1.291.75Z",
    transform: "translate(-285.832 -334.845)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61628",
    "data-name": "Group 61628",
    transform: "translate(2.725 3.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61627",
    "data-name": "Group 61627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35565",
    "data-name": "Path 35565",
    d: "M278.756,326.257l-1.291.75a.823.823,0,0,0,.343-.754l1.291-.75A.823.823,0,0,1,278.756,326.257Z",
    transform: "translate(-277.465 -325.503)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61630",
    "data-name": "Group 61630",
    transform: "translate(1.06 0.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61629",
    "data-name": "Group 61629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35566",
    "data-name": "Path 35566",
    d: "M260.828,304.454l1.291-.75a.83.83,0,0,1,.837.081l-1.291.75A.829.829,0,0,0,260.828,304.454Z",
    transform: "translate(-260.828 -303.624)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61632",
    "data-name": "Group 61632",
    transform: "translate(1.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61631",
    "data-name": "Group 61631"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35567",
    "data-name": "Path 35567",
    d: "M260.883,295.1l1.291-.751.262.031-1.291.75Z",
    transform: "translate(-260.883 -294.348)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61634",
    "data-name": "Group 61634",
    transform: "translate(1.328 0.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61633",
    "data-name": "Group 61633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35568",
    "data-name": "Path 35568",
    d: "M263.5,295.41l1.291-.75.049.169-1.291.75Z",
    transform: "translate(-263.504 -294.66)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61635",
    "data-name": "Group 61635",
    transform: "translate(3.563 3.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35569",
    "data-name": "Path 35569",
    d: "M285.92,331.233l1.291-.75a1.688,1.688,0,0,1-.088.437l-1.291.75A1.684,1.684,0,0,0,285.92,331.233Z",
    transform: "translate(-285.832 -330.483)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61636",
    "data-name": "Group 61636",
    transform: "translate(1.376 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35570",
    "data-name": "Path 35570",
    d: "M263.991,297.1l1.291-.751a1.745,1.745,0,0,1,.382.139l-1.291.75A1.748,1.748,0,0,0,263.991,297.1Z",
    transform: "translate(-263.991 -296.348)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61638",
    "data-name": "Group 61638",
    transform: "translate(0.716 1.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61637",
    "data-name": "Group 61637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35571",
    "data-name": "Path 35571",
    d: "M259.753,313.316a.973.973,0,0,1-.172.6c-.208.272-.583.318-1.008.072a2.585,2.585,0,0,1-1.173-2.03c0-.52.26-.825.638-.832a1.059,1.059,0,0,1,.542.16A2.588,2.588,0,0,1,259.753,313.316Z",
    transform: "translate(-257.4 -311.125)",
    fill: "#f2b929"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61640",
    "data-name": "Group 61640",
    transform: "translate(1.182 1.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61639",
    "data-name": "Group 61639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35572",
    "data-name": "Path 35572",
    d: "M263.935,313.316a.973.973,0,0,1-.172.6,1.058,1.058,0,0,1-.542-.16,2.588,2.588,0,0,1-1.173-2.031.971.971,0,0,1,.172-.6,1.059,1.059,0,0,1,.542.16A2.588,2.588,0,0,1,263.935,313.316Z",
    transform: "translate(-262.048 -311.125)",
    fill: "#fc8b13"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61642",
    "data-name": "Group 61642",
    transform: "translate(1.896 1.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61641",
    "data-name": "Group 61641"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35573",
    "data-name": "Path 35573",
    d: "M269.186,305.981l1.291-.75a2.587,2.587,0,0,1,1.172,2.03l-1.291.75A2.587,2.587,0,0,0,269.186,305.981Z",
    transform: "translate(-269.186 -305.231)",
    fill: "#2d2f3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61644",
    "data-name": "Group 61644",
    transform: "translate(3.652 3.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61643",
    "data-name": "Group 61643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35574",
    "data-name": "Path 35574",
    d: "M286.72,328l1.291-.751.133.077-1.291.75Z",
    transform: "translate(-286.72 -327.251)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61646",
    "data-name": "Group 61646",
    transform: "translate(3.784 3.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61645",
    "data-name": "Group 61645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35575",
    "data-name": "Path 35575",
    d: "M288.044,328.771l1.291-.75v.323l-1.291.751Z",
    transform: "translate(-288.043 -328.021)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61648",
    "data-name": "Group 61648",
    transform: "translate(1.758 0.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61647",
    "data-name": "Group 61647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35576",
    "data-name": "Path 35576",
    d: "M267.807,296.944l1.291-.75.282.163-1.291.75Z",
    transform: "translate(-267.807 -296.194)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61650",
    "data-name": "Group 61650",
    transform: "translate(2.039 0.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61649",
    "data-name": "Group 61649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35577",
    "data-name": "Path 35577",
    d: "M270.615,298.568l1.291-.75v.154l-1.291.751Z",
    transform: "translate(-270.615 -297.818)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61651",
    "data-name": "Group 61651",
    transform: "translate(3.581 2.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35578",
    "data-name": "Path 35578",
    d: "M286.015,323.211l1.291-.75a3.047,3.047,0,0,1,.07.48l-1.291.75A3.055,3.055,0,0,0,286.015,323.211Z",
    transform: "translate(-286.015 -322.461)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61653",
    "data-name": "Group 61653",
    transform: "translate(2.039 0.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61652",
    "data-name": "Group 61652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35579",
    "data-name": "Path 35579",
    d: "M270.615,300.108l1.291-.75a3.031,3.031,0,0,1,.423.344l-1.291.75A3.024,3.024,0,0,0,270.615,300.108Z",
    transform: "translate(-270.615 -299.358)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61654",
    "data-name": "Group 61654",
    transform: "translate(3.239 1.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35580",
    "data-name": "Path 35580",
    d: "M282.6,314.084l1.291-.75a4.129,4.129,0,0,1,.237.552l-1.291.75A4.124,4.124,0,0,0,282.6,314.084Z",
    transform: "translate(-282.6 -313.334)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61655",
    "data-name": "Group 61655",
    transform: "translate(2.721 1.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35581",
    "data-name": "Path 35581",
    d: "M277.425,306.3l1.291-.75a4.145,4.145,0,0,1,.32.436l-1.291.75A4.143,4.143,0,0,0,277.425,306.3Z",
    transform: "translate(-277.425 -305.549)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61657",
    "data-name": "Group 61657",
    transform: "translate(3.476 2.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61656",
    "data-name": "Group 61656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35582",
    "data-name": "Path 35582",
    d: "M284.964,319.6l1.291-.75.124.015-1.291.75Z",
    transform: "translate(-284.964 -318.85)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61659",
    "data-name": "Group 61659",
    transform: "translate(3.6 2.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61658",
    "data-name": "Group 61658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35583",
    "data-name": "Path 35583",
    d: "M286.2,319.751,287.5,319l.1.361-1.291.75Z",
    transform: "translate(-286.204 -319.001)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61661",
    "data-name": "Group 61661",
    transform: "translate(2.721 1.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61660",
    "data-name": "Group 61660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35584",
    "data-name": "Path 35584",
    d: "M277.478,305.2l1.291-.751-.053.11-1.291.75Z",
    transform: "translate(-277.425 -304.453)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61663",
    "data-name": "Group 61663",
    transform: "translate(2.515 0.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61662",
    "data-name": "Group 61662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35585",
    "data-name": "Path 35585",
    d: "M275.368,302.431l1.291-.751.258.278-1.291.751Z",
    transform: "translate(-275.368 -301.68)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61665",
    "data-name": "Group 61665",
    transform: "translate(3.041 1.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61664",
    "data-name": "Group 61664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35586",
    "data-name": "Path 35586",
    d: "M280.62,310.169l1.291-.75.095-.054-1.291.75Z",
    transform: "translate(-280.62 -309.365)",
    fill: "#4e4d58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61667",
    "data-name": "Group 61667",
    transform: "translate(3.136 1.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61666",
    "data-name": "Group 61666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35587",
    "data-name": "Path 35587",
    d: "M281.565,310.115l1.291-.75.2.343-1.291.751Z",
    transform: "translate(-281.565 -309.365)",
    fill: "#5e5e6a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61669",
    "data-name": "Group 61669",
    transform: "translate(0 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61668",
    "data-name": "Group 61668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35588",
    "data-name": "Path 35588",
    d: "M254.028,305.537l-.133-.077a1.685,1.685,0,0,1-.088.437l.122.131-.112.234-.122-.131a.906.906,0,0,1-.219.242l.094.163-.2.115-.094-.163a.959.959,0,0,1-.362.064l.05.172-.262-.031-.048-.169a1.7,1.7,0,0,1-.382-.138v.154l-.282-.163v-.154a3.075,3.075,0,0,1-.423-.344l-.053.11-.259-.277.053-.111a4.227,4.227,0,0,1-.32-.435l-.095.054-.2-.344.095-.054a4.075,4.075,0,0,1-.237-.552l-.124-.014-.1-.361.123.014a3.067,3.067,0,0,1-.07-.48l-.133-.077v-.324l.133.077a1.673,1.673,0,0,1,.088-.437l-.122-.132.112-.233.121.131a.911.911,0,0,1,.219-.243l-.094-.163.2-.114.094.163a.953.953,0,0,1,.362-.065l-.05-.171.262.031.049.169a1.742,1.742,0,0,1,.382.139v-.154l.282.163v.154a3.032,3.032,0,0,1,.423.344l.053-.111.259.278-.053.11a4.149,4.149,0,0,1,.32.436l.095-.054.2.343-.095.054a4.127,4.127,0,0,1,.237.552l.124.015.1.361-.123-.014a3.051,3.051,0,0,1,.07.48l.133.077Zm-1.9.1c.648.374,1.178.073,1.18-.672a2.587,2.587,0,0,0-1.172-2.03c-.648-.374-1.178-.073-1.18.672A2.588,2.588,0,0,0,252.133,305.634Z",
    transform: "translate(-250.244 -301.842)",
    fill: "#2d2f3c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61683",
    "data-name": "Group 61683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61682",
    "data-name": "Group 61682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61673",
    "data-name": "Group 61673",
    transform: "translate(0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61672",
    "data-name": "Group 61672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35589",
    "data-name": "Path 35589",
    d: "M245.559,286.492l1.393-.817.775-.442-1.393.817Z",
    transform: "translate(-245.559 -285.232)",
    fill: "#fc8b13"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61675",
    "data-name": "Group 61675",
    transform: "translate(4.829 3.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61674",
    "data-name": "Group 61674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35590",
    "data-name": "Path 35590",
    d: "M293.747,318.316l1.393-.817-.005,1.864-1.393.817Z",
    transform: "translate(-293.742 -317.499)",
    fill: "#f2b929"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61677",
    "data-name": "Group 61677",
    transform: "translate(4.064 1.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61676",
    "data-name": "Group 61676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35591",
    "data-name": "Path 35591",
    d: "M286.1,304.985l1.393-.817.771,1.335-1.393.817Z",
    transform: "translate(-286.098 -304.168)",
    fill: "#fed435"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61679",
    "data-name": "Group 61679",
    transform: "translate(0.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61678",
    "data-name": "Group 61678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35592",
    "data-name": "Path 35592",
    d: "M253.3,286.049l1.393-.817,3.284,1.9-1.393.817Z",
    transform: "translate(-253.3 -285.232)",
    fill: "#f2b929"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61681",
    "data-name": "Group 61681",
    transform: "translate(0 0.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61680",
    "data-name": "Group 61680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35593",
    "data-name": "Path 35593",
    d: "M249.57,295.292l.771,1.335-.005,1.864-.294-.17,0-1.724-.6-1.036-3.039-1.755-.6.343,0,1.724-.294-.17.005-1.864.775-.442Z",
    transform: "translate(-245.506 -293.396)",
    fill: "#fc8b13"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61687",
    "data-name": "Group 61687",
    transform: "translate(27.5 16.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61685",
    "data-name": "Group 61685",
    transform: "translate(0 0.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35594",
    "data-name": "Path 35594",
    d: "M320.64,238.161v.109a.237.237,0,0,1-.139.194.744.744,0,0,1-.673,0,.236.236,0,0,1-.139-.194v-.109Z",
    transform: "translate(-319.688 -237.886)",
    fill: "#5e5e6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35595",
    "data-name": "Path 35595",
    d: "M319.834,238.161l-.007.194v.11a.236.236,0,0,1-.139-.194v-.109Z",
    transform: "translate(-319.687 -237.886)",
    fill: "#393b47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35596",
    "data-name": "Path 35596",
    d: "M320.5,235.5a.205.205,0,0,1,0,.389.744.744,0,0,1-.673,0,.205.205,0,0,1,0-.389.744.744,0,0,1,.673,0Z",
    transform: "translate(-319.687 -235.416)",
    fill: "#4e4d58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61686",
    "data-name": "Group 61686",
    transform: "translate(0.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35597",
    "data-name": "Path 35597",
    d: "M321.432,231.048a.187.187,0,0,1-.11.154.588.588,0,0,1-.533,0,.187.187,0,0,1-.11-.154l.093-.753h.013l.553,0Z",
    transform: "translate(-320.679 -230.137)",
    fill: "#fd6445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35598",
    "data-name": "Path 35598",
    d: "M320.854,230.432l-.065.787a.187.187,0,0,1-.11-.154l.093-.753h.013Z",
    transform: "translate(-320.679 -230.155)",
    fill: "#ac2f11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35599",
    "data-name": "Path 35599",
    d: "M322.089,228.784a.122.122,0,0,1,0,.232.444.444,0,0,1-.4,0,.122.122,0,0,1,0-.232.444.444,0,0,1,.4,0Z",
    transform: "translate(-321.511 -228.736)",
    fill: "#e13d22"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61690",
    "data-name": "Group 61690",
    transform: "translate(32.264 14.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61688",
    "data-name": "Group 61688",
    transform: "translate(0 0.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35600",
    "data-name": "Path 35600",
    d: "M368.223,212.949v.11a.237.237,0,0,1-.139.194.743.743,0,0,1-.673,0,.236.236,0,0,1-.139-.194v-.11Z",
    transform: "translate(-367.271 -212.674)",
    fill: "#5e5e6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35601",
    "data-name": "Path 35601",
    d: "M367.417,212.949l-.007.194v.11a.236.236,0,0,1-.139-.194v-.11Z",
    transform: "translate(-367.27 -212.674)",
    fill: "#393b47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35602",
    "data-name": "Path 35602",
    d: "M368.083,210.283a.205.205,0,0,1,0,.389.744.744,0,0,1-.673,0,.205.205,0,0,1,0-.389.744.744,0,0,1,.673,0Z",
    transform: "translate(-367.27 -210.203)",
    fill: "#4e4d58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61689",
    "data-name": "Group 61689",
    transform: "translate(0.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35603",
    "data-name": "Path 35603",
    d: "M369.015,205.836a.187.187,0,0,1-.11.154.588.588,0,0,1-.533,0,.187.187,0,0,1-.11-.154l.093-.753h.013l.553,0Z",
    transform: "translate(-368.262 -204.925)",
    fill: "#fd6445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35604",
    "data-name": "Path 35604",
    d: "M368.437,205.22l-.065.788a.187.187,0,0,1-.11-.154l.093-.753h.013Z",
    transform: "translate(-368.262 -204.943)",
    fill: "#ac2f11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35605",
    "data-name": "Path 35605",
    d: "M369.672,203.572a.122.122,0,0,1,0,.232.444.444,0,0,1-.4,0,.122.122,0,0,1,0-.232.444.444,0,0,1,.4,0Z",
    transform: "translate(-369.094 -203.524)",
    fill: "#e13d22"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61693",
    "data-name": "Group 61693",
    transform: "translate(46.261 71.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61692",
    "data-name": "Group 61692",
    transform: "translate(0.02 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35606",
    "data-name": "Path 35606",
    d: "M57.925,160.413l.1.115v.111a.072.072,0,0,0,.012.036.088.088,0,0,0,.029.029l.245.142-.008.1.034.037.115-.066a.022.022,0,0,0,.012-.022v-.27a.072.072,0,0,0-.012-.036.087.087,0,0,0-.029-.029l-.077-.045-.279-.161a.034.034,0,0,0-.029,0Z",
    transform: "translate(-57.913 -160.345)",
    fill: "#4e4d58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35607",
    "data-name": "Path 35607",
    d: "M61.737,163.114l.034.037.115-.066a.022.022,0,0,0,.012-.022v-.27a.072.072,0,0,0-.012-.036l-.115.066S61.751,162.99,61.737,163.114Z",
    transform: "translate(-61.343 -162.515)",
    fill: "#5e5e6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35608",
    "data-name": "Path 35608",
    d: "M57.845,161.369l.279.161.077.045a.034.034,0,0,0,.029,0,.022.022,0,0,0,.012-.022v-.27a.071.071,0,0,0-.012-.036.088.088,0,0,0-.029-.029l-.077-.045-.279-.161a.034.034,0,0,0-.029,0,.022.022,0,0,0-.012.022v.27a.071.071,0,0,0,.012.036A.089.089,0,0,0,57.845,161.369Z",
    transform: "translate(-57.804 -160.943)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35609",
    "data-name": "Path 35609",
    d: "M57.659,161.269v.2a.054.054,0,0,0,.009.026.074.074,0,0,0,.023.023l.276.159.01.013.044.06.037-.022s0-.14,0-.14v-.135a.056.056,0,0,0-.009-.027.077.077,0,0,0-.023-.022l-.357-.206a.026.026,0,0,0-.011,0l-.039.022Z",
    transform: "translate(-57.619 -161.111)",
    fill: "#e13d22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35610",
    "data-name": "Path 35610",
    d: "M61.133,163.726l0,.056.044.06.037-.022s0-.14,0-.14v-.135a.056.056,0,0,0-.009-.027.259.259,0,0,0-.039.023C61.172,163.547,61.133,163.726,61.133,163.726Z",
    transform: "translate(-60.779 -163.2)",
    fill: "#fd6445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35611",
    "data-name": "Path 35611",
    d: "M58,161.956v-.275a.054.054,0,0,0-.009-.026.072.072,0,0,0-.023-.023l-.357-.206a.024.024,0,0,0-.011,0l0,.14v.135a.054.054,0,0,0,.009.026.071.071,0,0,0,.023.023l.357.206a.024.024,0,0,0,.011,0Z",
    transform: "translate(-57.6 -161.314)",
    fill: "#ac2f11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61695",
    "data-name": "Group 61695",
    transform: "translate(56.71 77.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61694",
    "data-name": "Group 61694",
    transform: "translate(0.021 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35612",
    "data-name": "Path 35612",
    d: "M162.288,221.157l.1.115v.111a.072.072,0,0,0,.012.036.088.088,0,0,0,.029.029l.245.142-.008.1.034.037.115-.066a.022.022,0,0,0,.012-.022v-.27a.071.071,0,0,0-.012-.036.089.089,0,0,0-.029-.029l-.077-.045-.279-.161a.034.034,0,0,0-.029,0Z",
    transform: "translate(-162.276 -221.089)",
    fill: "#4e4d58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35613",
    "data-name": "Path 35613",
    d: "M166.1,223.858l.034.037.115-.066a.022.022,0,0,0,.012-.022v-.27a.071.071,0,0,0-.012-.036l-.115.066S166.114,223.733,166.1,223.858Z",
    transform: "translate(-165.706 -223.259)",
    fill: "#5e5e6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35614",
    "data-name": "Path 35614",
    d: "M162.208,222.112l.279.161.077.045a.034.034,0,0,0,.029,0,.022.022,0,0,0,.012-.022v-.27a.071.071,0,0,0-.012-.036.088.088,0,0,0-.029-.029l-.077-.045-.279-.161a.034.034,0,0,0-.029,0,.022.022,0,0,0-.012.022v.27a.071.071,0,0,0,.012.036A.087.087,0,0,0,162.208,222.112Z",
    transform: "translate(-162.167 -221.687)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35615",
    "data-name": "Path 35615",
    d: "M162.021,222.011v.2a.053.053,0,0,0,.009.026.072.072,0,0,0,.023.023l.276.159.01.013.044.06.037-.022s0-.14,0-.14V222.2a.056.056,0,0,0-.009-.027.079.079,0,0,0-.023-.022l-.357-.206a.026.026,0,0,0-.011,0l-.039.022Z",
    transform: "translate(-161.981 -221.853)",
    fill: "#e13d22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35616",
    "data-name": "Path 35616",
    d: "M165.495,224.469l0,.056.044.06.037-.022s0-.14,0-.14v-.135a.056.056,0,0,0-.009-.027.259.259,0,0,0-.039.023C165.534,224.29,165.495,224.469,165.495,224.469Z",
    transform: "translate(-165.141 -223.943)",
    fill: "#fd6445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35617",
    "data-name": "Path 35617",
    d: "M162.363,222.7v-.275a.053.053,0,0,0-.009-.026.071.071,0,0,0-.023-.023l-.357-.206a.024.024,0,0,0-.011,0l0,.14v.135a.054.054,0,0,0,.009.026.071.071,0,0,0,.023.023l.357.206a.024.024,0,0,0,.011,0Z",
    transform: "translate(-161.962 -222.057)",
    fill: "#ac2f11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61697",
    "data-name": "Group 61697",
    transform: "translate(66.153 82.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61696",
    "data-name": "Group 61696",
    transform: "translate(0.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35618",
    "data-name": "Path 35618",
    d: "M256.615,276.7l.1.115v.111a.07.07,0,0,0,.012.036.089.089,0,0,0,.029.029l.245.142-.008.1.034.037.115-.066a.022.022,0,0,0,.012-.022v-.27a.071.071,0,0,0-.012-.036.089.089,0,0,0-.029-.029l-.077-.045-.279-.161a.033.033,0,0,0-.029,0Z",
    transform: "translate(-256.603 -276.634)",
    fill: "#4e4d58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35619",
    "data-name": "Path 35619",
    d: "M260.427,279.4l.034.037.115-.066a.022.022,0,0,0,.012-.022v-.27a.071.071,0,0,0-.012-.036l-.115.066S260.441,279.28,260.427,279.4Z",
    transform: "translate(-260.033 -278.805)",
    fill: "#5e5e6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35620",
    "data-name": "Path 35620",
    d: "M256.536,277.659l.279.161.077.045a.034.034,0,0,0,.029,0,.022.022,0,0,0,.012-.022v-.27a.072.072,0,0,0-.012-.036.089.089,0,0,0-.029-.029l-.077-.045-.279-.161a.034.034,0,0,0-.029,0,.022.022,0,0,0-.012.022v.27a.071.071,0,0,0,.012.036A.091.091,0,0,0,256.536,277.659Z",
    transform: "translate(-256.495 -277.233)",
    fill: "#393b47"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35621",
    "data-name": "Path 35621",
    d: "M256.35,277.556v.2a.053.053,0,0,0,.009.026.072.072,0,0,0,.023.023l.276.159.01.013.044.06.037-.022s0-.14,0-.14v-.135a.056.056,0,0,0-.009-.027.079.079,0,0,0-.023-.022l-.357-.206a.027.027,0,0,0-.011,0l-.039.022Z",
    transform: "translate(-256.31 -277.398)",
    fill: "#e13d22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35622",
    "data-name": "Path 35622",
    d: "M259.823,280.016l0,.056.044.06.037-.022s0-.14,0-.14v-.135a.057.057,0,0,0-.009-.027.26.26,0,0,0-.039.023C259.862,279.837,259.823,280.016,259.823,280.016Z",
    transform: "translate(-259.469 -279.49)",
    fill: "#fd6445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35623",
    "data-name": "Path 35623",
    d: "M256.691,278.245v-.275a.054.054,0,0,0-.009-.026.072.072,0,0,0-.023-.023l-.357-.206a.024.024,0,0,0-.011,0l0,.14v.135a.054.054,0,0,0,.009.026.071.071,0,0,0,.023.023l.357.206a.025.025,0,0,0,.011,0Z",
    transform: "translate(-256.29 -277.603)",
    fill: "#ac2f11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetTrackingVehicles);
export default __webpack_public_path__ + "static/media/AssetTrackingVehicles.efac28836cc2d3615f07a3d919e98c3a.svg";
export { ForwardRef as ReactComponent };